import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, AlertController } from '@ionic/angular';
import { MotoristaJornadaService } from 'src/app/services/motorista-jornada-service/motorista-jornada-service.service';
import { MotoristaJornadaDTO } from 'src/app/models/motoristaJornadaDTO';
import { AuthService } from 'src/app/services/auth.service';
import { JornadaServicoService } from 'src/app/services/jornada-servico/jornada-servico.service';
import { jwtDecode } from 'jwt-decode';
import { ActivatedRoute, Router } from '@angular/router';
import { RelatorioService } from 'src/app/services/relatorio-pdf/relatorio.service';
import { Storage } from '@ionic/storage-angular';
import { StorageService } from 'src/app/services/storage-service/storage.service';
import { Capacitor } from '@capacitor/core';
import { AcertoHoraService } from 'src/app/services/acerto-hora-service/acerto-hora.service';
import { AcertoHoraDTO } from 'src/app/services/acerto-hora-service/acerto-hora.service';
import { FolhaServicoService } from 'src/app/services/folha-servico-service/folha-servico.service';
import { WebSocketService } from 'src/app/services/websocket/websocket.service';
import { Network } from '@capacitor/network';
import { ElginPrintService } from 'src/app/services/print-service/elgin-print-service';
import { addIcons } from 'ionicons';
import {
  addOutline, createOutline, trashOutline, saveOutline, closeOutline,
  personCircleOutline, moveOutline, timeOutline, documentTextOutline,
  checkmarkCircleOutline, alertCircleOutline, informationCircleOutline,
  chevronDownOutline, checkmarkOutline, calendarOutline
} from 'ionicons/icons';
import { CercaEletronicaService, VerificacaoLocalizacao } from 'src/app/services/cerca-eletronica/cerca-eletronica-service';
import { ProximasEscalasModalComponent } from 'src/app/motorista-pages/proxima-escala-modal/proxima-escala-modal.component';
import { TelemetriaService } from 'src/app/services/telemetria-service/telemetria.service';
import { MensagemUsuario, MensagemUsuarioService } from 'src/app/services/mensagem-usuario-service/mensagem-usuario-service';
import { PapeletaExternaService } from 'src/app/services/papeleta-externa-service/papeleta-externa.service';

interface DiaApuradoCorrecao {
  data: Date;
  marcacoes: MarcacaoCorrecao[];
  situacoes: { tempo: string; descricao: string; tipo?: string }[];
  aviso?: string;
  folhaServicoId?: number;
  papeleta?: number;
}

interface StatusAssinaturaDia {
  podeAssinar: boolean;
  podeSolicitarExclusao: boolean;
  statusSolicitacao: string | null;
  textoBotao: string;
  corBotao: string;
  desabilitado: boolean;
  mensagem: string;
}

interface MarcacaoCorrecao {
  hora: string;
  diferenca?: string;
  incompleta?: boolean;
  acertoId?: number;
  motivo?: string;
  status?: string;
  acertoData?: string | null;
  papeleta?: number;
}

interface NovaMarcacaoTemp {
  hora: string;
  motivoId: number | null;
}

@Component({
  selector: 'app-first-page',
  templateUrl: './first-page.component.html',
  styleUrls: ['./first-page.component.scss'],
  imports: [CommonModule, FormsModule, IonicModule, ProximasEscalasModalComponent],
  standalone: true
})

export class FirstPageComponent implements OnInit {
  impressoraConectada = false;
  private _storage: Storage | null = null;
  tokenAutenticacao: string | null = null;
  private usuarioLogado: any = null;
  mostrarConfirmacaoAssinatura: boolean = false;
  motoristaParaAssinar: any = null;
  primeiroAcesso: boolean = true;
  acertoEditandoData: string | null = null;

  mostrarAlertaPendentes: boolean = false;
  mensagemAlertaPendentes: string = '';
  dadosPendentesAssinatura: any = null;
  alertaFechadoPermanente: boolean = false;

  mostrarModalPapeletaExterna: boolean = false;
  papeletaExternaCarregando: boolean = false;
  papeletaExternaSemDados: boolean = false;
  folhaExterna: any = null;
  listaTarefasExterna: any[] = [];

  mostrarModalEscalas: boolean = false;

  mensagensMotorista: MensagemUsuario[] = [];

  mostrarNovaMarcacao: boolean = false;
  diaSelecionadoParaAdicionar: DiaApuradoCorrecao | null = null;
  novaMarcacao: NovaMarcacaoTemp = { hora: '', motivoId: null };

  carregandoLocalizacao: boolean = false;
  ultimaLocalizacao: { latitude: number; longitude: number } | null = null;
  statusLocalizacao: VerificacaoLocalizacao | null = null;

  mostrarModalCorrecao: boolean = false;
  diasApuradosCorrecao: DiaApuradoCorrecao[] = [];
  diasFiltradosCorrecao: DiaApuradoCorrecao[] = [];
  filtroAtualCorrecao: 'todos' | 'pendentes' = 'todos';
  paginaAtualCorrecao: number = 1;
  itensPorPaginaCorrecao: number = 10;
  totalPaginasCorrecao: number = 1;
  Math = Math;
  isLoadingCorrecao: boolean = false;
  horariosTemporarios: { [folhaServicoId: number]: AcertoHoraDTO[] } = {};
  botaoStatus: { [folhaServicoId: number]: boolean } = {};

  // Variáveis para edição inline
  editandoAcertoId: number | null = null;
  acertoEditando: { hora: string; motivoId?: number } | null = null;
  motivosDisponiveis: any[] = [];

  statusDias: Map<string, StatusAssinaturaDia> = new Map();
  isLoadingStatus: boolean = false;
  diaParaAssinar: DiaApuradoCorrecao | null = null;

  exibirBotoesPapeletaBranco: boolean = true;
  exibirBotoesJornadaNormal: boolean = true;
  papeletaBrancoAtiva: boolean = false;
  tipoPapeletaAtiva: 'G' | 'B' | null = null;

  showPassword: boolean = false;

  telemetriaService = inject(TelemetriaService);
  carregandoLocalizacaoVeiculo = false;

  togglePassword() {
    this.showPassword = !this.showPassword;
  }


  private getColetorMarcacao(): string {
    return Capacitor.isNativePlatform() ? '01' : '02';
  }

  constructor(
    private alertController: AlertController,
    private motoristaService: MotoristaJornadaService,
    private authService: AuthService,
    private jornadaServicoService: JornadaServicoService,
    private router: Router,
    private relatorioService: RelatorioService,
    private storage: Storage,
    private storageService: StorageService,
    private acertoHoraService: AcertoHoraService,
    private folhaServicoService: FolhaServicoService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private webSocketService: WebSocketService,
    private elginPrintService: ElginPrintService,
    private cercaService: CercaEletronicaService,
    private mensagemService: MensagemUsuarioService,
    private papeletaExternaService: PapeletaExternaService
  ) {
    addIcons({
      addOutline, createOutline, trashOutline, saveOutline, closeOutline,
      personCircleOutline, moveOutline, timeOutline, documentTextOutline,
      checkmarkCircleOutline, alertCircleOutline, informationCircleOutline,
      chevronDownOutline, checkmarkOutline, calendarOutline
    });
  }

  async ngOnInit() {

    // Busca token do sessionStorage ANTES de limpar
    const tokenSalvo = sessionStorage.getItem('token');
    const matriculaSalva = sessionStorage.getItem('matricula');

    localStorage.clear();
    this._storage = await this.storage.create();
    await this._storage.clear();

    // Verifica se existe servidor configurado
    const servidor = await this.storageService.getServidor();

    if (!servidor || !servidor.url_servidor) {
      this.router.navigate(['/url-servico']);
      return;
    }

    // Login automático
    if (tokenSalvo && matriculaSalva) {
      this.tokenAutenticacao = tokenSalvo;
      this.searchTerm = matriculaSalva;
      this.carregarDadosMotorista(matriculaSalva);

      sessionStorage.removeItem('token');
      sessionStorage.removeItem('matricula');
    }

    // Inscreve para receber notificações de status de assinatura
    this.webSocketService.getNotificacoesStatus().subscribe((notificacao: any) => {
      console.log('📨 Notificação recebida:', notificacao);

      if (notificacao.status === 'ACEITA') {
        this.toastMessage = `Sua solicitação de exclusão da papeleta ${notificacao.numeroPapeleta} foi APROVADA!`;
      } else if (notificacao.status === 'NEGADA') {
        this.toastMessage = `Sua solicitação de exclusão da papeleta ${notificacao.numeroPapeleta} foi RECUSADA!`;
      }
      this.showToast = true;

      // Recarrega os dados do motorista
      if (this.motoristas.length > 0) {
        this.carregarDadosMotorista(this.motoristas[0].matricula);
      }
    });
    this.conectarImpressora();
  }

  ionViewWillEnter() {

    this.carregarMensagensMotorista();

    if (!this.primeiroAcesso) {
      this.limparSessao();
    }
    this.primeiroAcesso = false;
  }

  limparSessao() {
    this.searchTerm = '';
    this.senhaDigitada = '';
    this.mostrarSenha = false;
    this.acaoPendente = null;
    this.tokenAutenticacao = null;
    this.usuarioLogado = null;
    this.motoristas = [];
    this.motoristasFiltrados = [];
    this.acertosHorarios = [];
    this.horariosTemporarios = {};
    this.limparEstadoAlertaPendentes();
  }

  searchTerm: string = '';
  senhaDigitada: string = '';
  mostrarSenha: boolean = false;
  acaoPendente: { motorista: any, tipo: string } | null = null;

  showToast: boolean = false;
  toastMessage: string = '';

  latitude: number = 0;
  longitude: number = 0;

  motoristas: MotoristaJornadaDTO[] = [];
  motoristasFiltrados: MotoristaJornadaDTO[] = [];
  acertosHorarios: AcertoHoraDTO[] = [];

  // Método para login do usuário
  fazerLogin() {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      this.toastMessage = 'Digite a matrícula do motorista!';
      this.showToast = true;
      return;
    }

    // Armazena a matrícula digitada
    const matricula = this.searchTerm.trim();

    // Mostra popup de senha
    this.mostrarSenha = true;
    this.senhaDigitada = '';

    // Armazena a matrícula para usar na validação
    this.acaoPendente = { motorista: { matricula: matricula }, tipo: 'login' };

    setTimeout(() => {
      this.focarCampoSenha();
    }, 100);
  }

  private focarCampoSenha() {
    // Busca o elemento ion-input dentro do mini-card
    const ionInputs = document.querySelectorAll('.mini-card .password-item ion-input');
    if (ionInputs && ionInputs.length > 0) {
      const ionInput = ionInputs[0] as HTMLIonInputElement;

      // 🔥 FOCA USANDO O MÉTODO NATIVO DO ION-INPUT
      ionInput.setFocus();

      // 🔥 ADICIONA CLASSE NO ELEMENTO PAI (ion-item) EM VEZ DO INPUT
      const parentItem = ionInput.closest('.password-item');
      if (parentItem) {
        parentItem.classList.add('senha-focus');
      }
    }
  }

  validarSenha() {
    if (this.acaoPendente) {
      if (this.acaoPendente.tipo === 'login') {
        // Login do usuário
        const matricula = this.acaoPendente.motorista.matricula;

        this.authService.login(matricula, this.senhaDigitada).then(token => {
          const decoded: any = jwtDecode(token);

          if (decoded.trocarSenha) {
            this.toastMessage = 'Você precisa trocar sua senha antes de continuar.';
            this.showToast = true;

            this.router.navigate(['/auth/change-password'], {
              queryParams: { identificador: matricula, origem: 'first-page' }
            });

            this.carregarDadosMotorista(matricula);
            this.resetarConfirmacao();
            return;
          }

          // Login bem sucedido
          this.tokenAutenticacao = token;
          this.usuarioLogado = decoded;

          // Carrega os dados do motorista logado
          this.carregarDadosMotorista(matricula);

          this.resetarConfirmacao();

        }).catch(() => {
          this.toastMessage = 'Matrícula ou senha incorretos!';
          this.showToast = true;
          this.senhaDigitada = '';
        });
      } else {
        // Iniciar ou finalizar jornada (já está logado, não precisa de senha novamente)
        const motorista = this.acaoPendente.motorista;

        if (this.acaoPendente.tipo === 'iniciar') {
          this.iniciarJornada(motorista, this.tokenAutenticacao!);
        } else {
          this.finalizarJornada(motorista, this.tokenAutenticacao!);
        }

        this.resetarConfirmacao();
      }
    }
  }

  carregarDadosMotorista(identificador: string) {
    this.motoristaService.listarMotoristas().subscribe({
      next: (data) => {
        const motoristaEncontrado = data.find(m =>
          m.matricula === identificador ||
          m.cpf === identificador
        );

        if (motoristaEncontrado) {
          this.motoristas = [motoristaEncontrado];
          this.motoristasFiltrados = [motoristaEncontrado];
          this.searchTerm = motoristaEncontrado.matricula;

          this.carregarMensagensMotorista();
          // Carrega os acertos de hora do motorista
          this.carregarAcertosHorarios(motoristaEncontrado.idFolhaServico, motoristaEncontrado.usuarioId);

          const matriculaNumero = parseInt(motoristaEncontrado.matricula, 10);
          if (!isNaN(matriculaNumero)) {
            this.verificarPendenciasAssinatura(matriculaNumero);
          }

        } else {
          this.toastMessage = 'Motorista não encontrado!';
          this.showToast = true;
          this.motoristas = [];
          this.motoristasFiltrados = [];
          this.acertosHorarios = [];
        }
      },
      error: (err) => {
        console.error('Erro ao carregar motorista:', err);
        this.toastMessage = 'Erro ao carregar dados do motorista!';
        this.showToast = true;
        this.motoristas = [];
        this.motoristasFiltrados = [];
        this.acertosHorarios = [];
      }
    });
  }

  /*carregarAcertosHorarios(folhaServicoId: number, usuarioId: number) {
    this.acertoHoraService.listar(folhaServicoId, usuarioId).subscribe({
      next: (acertos: AcertoHoraDTO[]) => {
        const acertosNaoExcluidos = (acertos || []).filter(acerto => {
          return !acerto.excluido && acerto.hora && acerto.hora.trim() !== '';
        });

        // Marca os que vieram do banco
        acertosNaoExcluidos.forEach(a => (a as any).origem = 'banco');

        // Remove os temporários antigos desta folha
        this.acertosHorarios = this.acertosHorarios.filter(a =>
          a.folhaServicoId !== folhaServicoId || (a as any).origem !== 'temp'
        );

        // Adiciona os do banco
        this.acertosHorarios = [...this.acertosHorarios, ...acertosNaoExcluidos];

        // Atualiza o status do botão baseado no TOTAL de acertos
        this.atualizarBotaoStatus(folhaServicoId);

        // 🔥 Verifica o tipo de papeleta ativa
        this.verificarTipoPapeletaAtiva(folhaServicoId);

        //this.verificarPapeletaBrancoAtiva();

        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Erro ao carregar acertos:', err);
      }
    });
  }*/
  carregarAcertosHorarios(folhaServicoId: number, usuarioId: number) {
    this.acertoHoraService.listar(folhaServicoId, usuarioId).subscribe({
      next: (acertos: AcertoHoraDTO[]) => {
        const acertosNaoExcluidos = (acertos || []).filter(acerto => {
          return !acerto.excluido && acerto.hora && acerto.hora.trim() !== '';
        });

        // Marca os que vieram do banco
        acertosNaoExcluidos.forEach(a => (a as any).origem = 'banco');

        // 🔥 SUBSTITUI COMPLETAMENTE os acertos da folha (remove os antigos)
        // Remove todos os acertos desta folha, tanto do banco quanto temporários
        this.acertosHorarios = this.acertosHorarios.filter(a =>
          a.folhaServicoId !== folhaServicoId
        );

        // Adiciona os novos acertos do banco
        this.acertosHorarios = [...this.acertosHorarios, ...acertosNaoExcluidos];

        // Limpa os temporários desta folha
        delete this.horariosTemporarios[folhaServicoId];

        // Atualiza o status do botão
        this.atualizarBotaoStatus(folhaServicoId);

        // Verifica o tipo de papeleta ativa
        this.verificarTipoPapeletaAtiva(folhaServicoId);

        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Erro ao carregar acertos:', err);
      }
    });
  }

  atualizarBotaoStatus(folhaServicoId: number) {
    // Pega acertos do banco
    const acertosBanco = this.acertosHorarios.filter(
      acerto => acerto.folhaServicoId === folhaServicoId &&
        !acerto.excluido &&
        (acerto as any).origem === 'banco'
    );

    // Pega acertos temporários
    const acertosTemp = this.horariosTemporarios[folhaServicoId] || [];

    // Total = banco + temporarios
    const totalAcertos = acertosBanco.length + acertosTemp.length;

    // Se for PAR mostra INICIAR (true), se for ÍMPAR mostra FINALIZAR (false)
    this.botaoStatus[folhaServicoId] = totalAcertos % 2 === 0;
  }

  // Método para dividir acertos em grupos de 4 (JÁ ORDENADOS)
  getAcertosAgrupados(): AcertoHoraDTO[][] {
    // 🔥 ORDENA OS ACERTOS POR DATA + HORA
    const acertosOrdenados = [...this.acertosHorarios].sort((a, b) => {
      const dataHoraA = this.criarDataParaComparacao(a.data || '', a.hora || '');
      const dataHoraB = this.criarDataParaComparacao(b.data || '', b.hora || '');
      return dataHoraA.getTime() - dataHoraB.getTime();
    });

    const grupos = [];
    for (let i = 0; i < acertosOrdenados.length; i += 4) {
      grupos.push(acertosOrdenados.slice(i, i + 4));
    }
    return grupos;
  }

  carregarMotoristas() {
    // Método mantido para compatibilidade mas não será usado diretamente
    this.motoristaService.listarMotoristas().subscribe({
      next: (data) => {
        this.motoristas = data;
        this.motoristasFiltrados = [...this.motoristas];
      },
      error: (err) => {
        console.error('Erro ao carregar motoristas:', err);
      }
    });
  }

  filtrarMotoristas() {
    // Como só tem um motorista, o filtro é simples
    if (this.motoristas.length > 0) {
      const termo = this.searchTerm.toLowerCase();
      this.motoristasFiltrados = this.motoristas.filter(m =>
        m.matricula.toLowerCase().includes(termo) ||
        m.nome.toLowerCase().includes(termo)
      );
    }
  }

  cancelarSenha() {
    this.resetarConfirmacao();
  }

  resetarConfirmacao() {
    this.mostrarSenha = false;
    this.senhaDigitada = '';
    this.acaoPendente = null;

    // Se não tiver usuário logado, não mantém o filtro
    if (!this.tokenAutenticacao) {
      this.searchTerm = '';
      this.motoristas = [];
      this.motoristasFiltrados = [];
      this.acertosHorarios = [];
    }
  }

  async iniciarJornada(motorista: MotoristaJornadaDTO, token: string) {
    const horaAtual = this.getHoraAtual();
    const status = await Network.getStatus();

    const payload = {
      usuario_id: motorista.usuarioId,
      folha_servico_id: motorista.idFolhaServico,
      data_servico: motorista.dataServico,
      resumo_papeleta_empregado_id: motorista.resumoPapeletaEmpregadoId,
      numero_papeleta: motorista.papeleta,
      latitude_inicio: this.latitude,
      longitude_inicio: this.longitude,
      hora_inicial: horaAtual,
      horario_inicial: motorista.horarioInicial,
      horario_final: motorista.horarioFinal,
      id: motorista.idFolhaServico,
      horaInicial: horaAtual,
      latitude_papeleta_inicio: this.latitude,
      longitude_papeleta_inicio: this.longitude,
      coletorMarcacao: this.getColetorMarcacao()
    };

    try {
      const response = await this.jornadaServicoService.iniciarJornadaServicoOffline(payload);
      console.log('Resposta iniciar:', response);

      // Cria acerto temporário
      const novoAcertoTemp: AcertoHoraDTO = {
        id: Date.now(),
        hora: horaAtual,
        statusAcertoHora: 'Pendente',
        excluido: false,
        folhaServicoId: motorista.idFolhaServico,
        usuario: motorista.matricula?.toString(),
        origem: 'temp',
        offline: !status.connected,           // 🔥 ADICIONAR
        coletorMarcacao: this.getColetorMarcacao()
      };

      if (!this.horariosTemporarios[motorista.idFolhaServico]) {
        this.horariosTemporarios[motorista.idFolhaServico] = [];
      }
      this.horariosTemporarios[motorista.idFolhaServico].push(novoAcertoTemp);

      // Atualiza a tela com os temporários
      this.atualizarListaAcertosComTemporarios(motorista.idFolhaServico);

      // FORÇA ATUALIZAÇÃO DA TELA
      this.cdr.detectChanges();

      //this.exibirBotoesPapeletaBranco = false;
      this.atualizarVisibilidadeBotoes();

      this.toastMessage = 'Jornada iniciada com sucesso!';
      this.showToast = true;

    } catch (error) {
      console.error('Erro ao iniciar jornada:', error);
      this.toastMessage = this.extrairMensagemErro(error, 'Erro ao finalizar jornada!');
      this.showToast = true;
    }
  }

  async finalizarJornada(motorista: MotoristaJornadaDTO, token: string) {
    const horaAtual = this.getHoraAtual();
    const status = await Network.getStatus();

    const payload = {
      usuario_id: motorista.usuarioId,
      numero_papeleta: motorista.papeleta,
      observacao: 'Finalização pelo app',
      latitude_fim: this.latitude,
      longitude_fim: this.longitude,
      hora_final: horaAtual,
      folha_servico_id: motorista.idFolhaServico,
      horaFim: horaAtual,
      latitude_papeleta_fim: this.latitude,
      longitude_papeleta_fim: this.longitude,
      coletorMarcacao: this.getColetorMarcacao()
    };

    try {
      const response = await this.jornadaServicoService.finalizarJornadaServicoOffline(payload);
      console.log('Resposta finalizar:', response);

      // Cria UM acerto temporário
      const novoAcertoTemp: AcertoHoraDTO = {
        id: Date.now(),
        hora: horaAtual,
        statusAcertoHora: 'Pendente',
        excluido: false,
        folhaServicoId: motorista.idFolhaServico,
        usuario: motorista.matricula?.toString(),
        offline: !status.connected,
        coletorMarcacao: this.getColetorMarcacao()
      };

      if (!this.horariosTemporarios[motorista.idFolhaServico]) {
        this.horariosTemporarios[motorista.idFolhaServico] = [];
      }
      this.horariosTemporarios[motorista.idFolhaServico].push(novoAcertoTemp);

      // Atualiza a tela com os temporários
      this.atualizarListaAcertosComTemporarios(motorista.idFolhaServico);

      //this.exibirBotoesPapeletaBranco = true;
      this.atualizarVisibilidadeBotoes();

      this.toastMessage = 'Jornada finalizada com sucesso!';
      this.showToast = true;

    } catch (error) {
      console.error('Erro ao finalizar jornada:', error);
      this.toastMessage = this.extrairMensagemErro(error, 'Erro ao finalizar jornada!');
      this.showToast = true;
    }
  }

  /*atualizarListaAcertosComTemporarios(folhaServicoId: number) {
    // Pega SOMENTE acertos do banco (ignora os que são temporários)
    const acertosBanco = this.acertosHorarios.filter(
      a => a.folhaServicoId === folhaServicoId && !a.excluido && (a as any).origem === 'banco'
    );

    // Pega acertos temporários
    const acertosTemp = this.horariosTemporarios[folhaServicoId] || [];

    // SOMA: banco + temporários
    const todosAcertos = [...acertosBanco, ...acertosTemp];

    todosAcertos.sort((a, b) => (a.hora || '').localeCompare(b.hora || ''));

    this.acertosHorarios = [
      ...this.acertosHorarios.filter(a => a.folhaServicoId !== folhaServicoId),
      ...todosAcertos
    ];

    // Atualiza o status do botão
    this.atualizarBotaoStatus(folhaServicoId);

    this.cdr.detectChanges();
  }*/
  atualizarListaAcertosComTemporarios(folhaServicoId: number) {
    // Pega SOMENTE acertos do banco (ignora os que são temporários)
    const acertosBanco = this.acertosHorarios.filter(
      a => a.folhaServicoId === folhaServicoId &&
        !a.excluido &&
        (a as any).origem === 'banco'
    );

    // Pega acertos temporários
    const acertosTemp = this.horariosTemporarios[folhaServicoId] || [];

    // SOMA: banco + temporários
    const todosAcertos = [...acertosBanco, ...acertosTemp];

    // 🔥 REMOVE todos os acertos desta folha (incluindo temporários antigos)
    this.acertosHorarios = this.acertosHorarios.filter(
      a => a.folhaServicoId !== folhaServicoId
    );

    // Adiciona os acertos atualizados
    this.acertosHorarios = [...this.acertosHorarios, ...todosAcertos];

    // Atualiza o status do botão
    this.atualizarBotaoStatus(folhaServicoId);

    this.cdr.detectChanges();
  }

  private limparDadosDaFolha(folhaServicoId: number) {
    // Remove acertos da folha
    this.acertosHorarios = this.acertosHorarios.filter(
      a => a.folhaServicoId !== folhaServicoId
    );

    // Remove temporários
    delete this.horariosTemporarios[folhaServicoId];
  }

  atualizarLista() {
    // Este método agora faz logout e limpa a sessão
    this.limparSessao();
    this.toastMessage = 'Sessão encerrada!';
    this.showToast = true;
  }

  private getHoraAtual(): string {
    const agora = new Date();
    const horas = agora.getHours().toString().padStart(2, '0');
    const minutos = agora.getMinutes().toString().padStart(2, '0');
    const segundos = agora.getSeconds().toString().padStart(2, '0');
    return `${horas}:${minutos}:${segundos}`;
  }

  iniciarDireto(motorista: any) {
    if (!this.tokenAutenticacao) {
      this.toastMessage = 'Faça login primeiro!';
      this.showToast = true;
      return;
    }

    // Não pede senha novamente, só executa a ação
    this.iniciarJornada(motorista, this.tokenAutenticacao);
  }

  finalizarDireto(motorista: any) {
    if (!this.tokenAutenticacao) {
      this.toastMessage = 'Faça login primeiro!';
      this.showToast = true;
      return;
    }

    // Não pede senha novamente, só executa a ação
    this.finalizarJornada(motorista, this.tokenAutenticacao);
  }

  async limparServidor() {
    try {
      const db = await this.storageService['dbPromise'];
      await (await db).clear('servidor');

      this.toastMessage = 'Servidor limpo com sucesso!';
      this.showToast = true;

      this.router.navigate(['/url-servico']);
    } catch (error) {
      console.error('Erro ao limpar servidor:', error);
      this.toastMessage = 'Erro ao limpar servidor!';
      this.showToast = true;
    }
  }

  async exportarPDF(motorista: any) {
    if (!motorista.matricula || !motorista.dataServico) {
      this.toastMessage = 'Dados insuficientes para gerar o PDF.';
      this.showToast = true;
      return;
    }

    if (!motorista.idFolhaServico) {
      this.toastMessage = 'ID da folha de serviço não encontrado!';
      this.showToast = true;
      return;
    }

    const loading = await this.alertController.create({
      message: 'Preparando dados...',
      backdropDismiss: false
    });
    await loading.present();

    try {
      const acertos = await this.acertoHoraService.listar(
        motorista.idFolhaServico,
        motorista.usuarioId
      ).toPromise();

      console.log('Acertos criados/carregados:', acertos);

      const data = motorista.dataServico.split('T')[0];

      // 🔥 CORREÇÃO: Adiciona o folhaServicoId
      this.relatorioService
        .gerarPdfPapeleta(motorista.matricula, data, false, motorista.idFolhaServico)
        .subscribe({
          next: (blob: Blob) => {
            loading.dismiss();
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
          },
          error: (error) => {
            loading.dismiss();
            console.error('Erro ao gerar PDF:', error);
            this.toastMessage = 'Erro ao gerar o PDF.';
            this.showToast = true;
          }
        });
    } catch (error) {
      loading.dismiss();
      console.error('Erro ao criar acertos:', error);
      this.toastMessage = 'Erro ao preparar dados para o PDF.';
      this.showToast = true;
    }
  }

  // Método para abrir o pop-up de confirmação de assinatura
  async assinarPapeleta(motorista: any) {
    if (!this.tokenAutenticacao) {
      this.toastMessage = 'Faça login primeiro!';
      this.showToast = true;
      return;
    }

    // 🔥 VALIDA SE PODE ASSINAR
    const validacao = this.podeAssinarPapeleta(motorista);

    if (!validacao.pode) {
      this.toastMessage = validacao.mensagem;
      this.showToast = true;
      return;
    }

    // Armazena o motorista e mostra o pop-up de confirmação
    this.motoristaParaAssinar = motorista;
    this.mostrarConfirmacaoAssinatura = true;
  }

  // Método chamado ao cancelar a assinatura
  cancelarAssinatura() {
    this.mostrarConfirmacaoAssinatura = false;
    this.motoristaParaAssinar = null;
    this.toastMessage = 'Assinatura cancelada.';
    this.showToast = true;
  }

  async exportarPDFComAssinatura(motorista: any) {
    if (!motorista.matricula || !motorista.dataServico) {
      this.toastMessage = 'Dados insuficientes para gerar o PDF.';
      this.showToast = true;
      return;
    }

    if (!motorista.idFolhaServico) {
      this.toastMessage = 'ID da folha de serviço não encontrado!';
      this.showToast = true;
      return;
    }

    const loading = await this.alertController.create({
      message: 'Preparando dados...',
      backdropDismiss: false
    });
    await loading.present();

    try {
      const data = motorista.dataServico.split('T')[0];

      // 🔥 CORREÇÃO: Adiciona o folhaServicoId
      this.relatorioService
        .gerarPdfPapeleta(motorista.matricula, data, true, motorista.idFolhaServico)
        .subscribe({
          next: (blob: Blob) => {
            loading.dismiss();
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
            this.toastMessage = 'Papeleta assinada com sucesso!';
            this.showToast = true;
          },
          error: (error: any) => {
            loading.dismiss();
            console.error('Erro ao gerar PDF:', error);

            let mensagemErro = 'Erro ao gerar o PDF assinado.';

            if (error && error.erro) {
              mensagemErro = error.erro;
            } else if (error && error.mensagem) {
              mensagemErro = error.mensagem;
            } else if (error && error.message) {
              mensagemErro = error.message;
            } else if (typeof error === 'string') {
              mensagemErro = error;
            }

            this.toastMessage = mensagemErro;
            this.showToast = true;
          }
        });
    } catch (error) {
      loading.dismiss();
      console.error('Erro:', error);
      this.toastMessage = 'Erro ao preparar dados para o PDF.';
      this.showToast = true;
    }
  }

  sair() {
    this.limparSessao();

    this.toastMessage = 'Sessão encerrada! Faça login novamente.';
    this.showToast = true;

    this.limparEstadoAlertaPendentes();
    localStorage.removeItem('token');

    window.location.reload();
  }

  // Método para abrir o modal de correção de horário
  async abrirCorrecaoHorario(motorista: any) {
    if (!this.tokenAutenticacao) {
      this.toastMessage = 'Faça login primeiro!';
      this.showToast = true;
      return;
    }

    this.motoristaParaAssinar = motorista;
    this.isLoadingCorrecao = true;
    this.mostrarModalCorrecao = true;

    // Carrega os motivos disponíveis
    await this.carregarMotivos();

    // Carrega os dias apurados
    await this.carregarDiasApurados(motorista);

    this.isLoadingCorrecao = false;
  }

  // Fechar modal de correção
  fecharModalCorrecao() {
    this.mostrarModalCorrecao = false;
    this.diasApuradosCorrecao = [];
    this.diasFiltradosCorrecao = [];
    this.editandoAcertoId = null;
  }

  // Carregar motivos
  async carregarMotivos() {
    try {
      this.motivosDisponiveis = await this.acertoHoraService.listarMotivos().toPromise() || [];
    } catch (error) {
      console.error('Erro ao carregar motivos:', error);
      this.motivosDisponiveis = [];
    }
  }

  /*async carregarDiasApurados(motorista: any) {
    try {
      this.isLoadingCorrecao = true;
      this.isLoadingStatus = true;

      this.limparDadosDaFolha(motorista.idFolhaServico);

      const hoje = new Date();
      const dataFim = hoje.toISOString().split('T')[0];
      const dataInicio = new Date(hoje);
      dataInicio.setDate(hoje.getDate() - 34);
      const dataInicioStr = dataInicio.toISOString().split('T')[0];

      console.log('Buscando folhas para motorista ID:', motorista.usuarioId);
      console.log('Período:', dataInicioStr, 'até', dataFim);

      const folhas = await this.folhaServicoService.buscarPorPeriodo(
        motorista.usuarioId,
        dataInicioStr,
        dataFim
      ).toPromise();

      console.log('Folhas encontradas:', folhas);

      if (!folhas || folhas.length === 0) {
        this.diasApuradosCorrecao = [];
        this.filtrarDiasCorrecao('todos');
        this.calcularPaginacaoCorrecao();
        this.toastMessage = 'Nenhuma folha de serviço encontrada neste período.';
        this.showToast = true;
        this.isLoadingCorrecao = false;
        this.isLoadingStatus = false;
        return;
      }

      // 🔥 LIMPA O CACHE ANTES DE RECARREGAR
      this.statusDias.clear();

      const dias: DiaApuradoCorrecao[] = [];

      // 🔥 USA Promise.all PARA CARREGAR TODOS OS STATUS EM PARALELO
      const promises = folhas.map(async (folha) => {
        try {
          const response = await this.acertoHoraService.buscarAcertosPorFolhaServico(folha.id).toPromise();

          const data = new Date(folha.dataServico + 'T00:00:00');
          const papeleta = response?.papeleta || folha.papeleta || 0;

          // 🔥 FILTRA ACERTOS NÃO EXCLUÍDOS
          const acertosNaoExcluidos = (response?.acertos || []).filter((acerto: any) => {
            return !acerto.excluido && acerto.horaAcerto && acerto.horaAcerto.trim() !== '';
          });

          console.log(`Folha ${folha.id} - ${folha.dataServico} - Acertos:`, acertosNaoExcluidos.length);

          // 🔥 CRIA MARCAÇÕES MESMO SE NÃO TIVER ACERTOS (array vazio)
          const marcacoes: MarcacaoCorrecao[] = acertosNaoExcluidos.map((acerto: any) => ({
            hora: this.formatarHora(acerto.horaAcerto || ''),
            diferenca: 'Acerto',
            incompleta: false,
            acertoId: acerto.acertoId,
            motivo: acerto.motivoAcertoHoraId?.toString(),
            status: acerto.status,
            acertoData: acerto.dataAcerto || folha.dataServico,
            papeleta: papeleta
          }));

          //marcacoes.sort((a, b) => a.hora.localeCompare(b.hora));

          // Substitua a ordenação das marcações em carregarDiasApurados por:

          marcacoes.sort((a, b) => {
            // Calcula a hora estendida para exibição
            const horaExibicaoA = this.calcularHoraEstendida(
              a.hora || '00:00',
              a.acertoData || folha.dataServico,
              data
            );
            const horaExibicaoB = this.calcularHoraEstendida(
              b.hora || '00:00',
              b.acertoData || folha.dataServico,
              data
            );

            const minutosA = this.converterHoraEstendidaParaMinutos(horaExibicaoA);
            const minutosB = this.converterHoraEstendidaParaMinutos(horaExibicaoB);

            return minutosA - minutosB;
          });

          // Determina situações
          const situacoes: any[] = [];

          if (acertosNaoExcluidos.length === 0) {
            // 🔥 FOLHA SEM ACERTOS - mostra "Sem acertos"
            situacoes.push({
              tempo: '',
              descricao: 'Sem acertos - Clique em "Adicionar acerto" para incluir',
              tipo: 'info'
            });
          } else {
            const temPendente = acertosNaoExcluidos.some((a: any) => a.status === 'Pendente');
            const temAutorizado = acertosNaoExcluidos.some((a: any) => a.status === 'Autorizado');
            const temMarcado = acertosNaoExcluidos.some((a: any) => a.status === 'Marcado');
            const temRecusado = acertosNaoExcluidos.some((a: any) => a.status === 'Recusado');

            if (temPendente) {
              situacoes.push({ tempo: '', descricao: 'Acerto pendente', tipo: 'Pendente' });
            }
            if (temAutorizado) {
              situacoes.push({ tempo: '', descricao: 'Acerto autorizado', tipo: 'Autorizado' });
            }
            if (temMarcado) {
              situacoes.push({ tempo: '', descricao: 'Horário marcado', tipo: 'Marcado' });
            }
            if (temRecusado) {
              situacoes.push({ tempo: '', descricao: 'Acerto recusado', tipo: 'Recusado' });
            }
          }

          // 🔥 CRIA O DIA (mesmo sem acertos)
          const dia: DiaApuradoCorrecao = {
            data: data,
            marcacoes: marcacoes,
            situacoes: situacoes,
            folhaServicoId: folha.id,
            papeleta: papeleta,
            aviso: acertosNaoExcluidos.length === 0 ? 'Sem acertos' : undefined
          };

          // 🔥 CARREGA O STATUS E ARMAZENA NO CACHE COM A CHAVE CORRETA
          const status = await this.verificarStatusAssinaturaDia(
            folha.id,
            String(papeleta),
            data
          );

          // 🔥 CHAVE CORRETA: data + papeleta
          const key = `${data.toISOString().split('T')[0]}_${papeleta}`;
          this.statusDias.set(key, status);
          console.log(`✅ Status carregado para ${key}:`, status);

          return dia;

        } catch (error) {
          console.error(`Erro ao carregar acertos da folha ${folha.id}:`, error);
          const data = new Date(folha.dataServico + 'T00:00:00');
          // 🔥 MESMO COM ERRO, ADICIONA O DIA VAZIO
          return {
            data: data,
            marcacoes: [],
            situacoes: [{ tempo: '', descricao: 'Erro ao carregar - clique em Adicionar acerto', tipo: 'erro' }],
            folhaServicoId: folha.id,
            papeleta: folha.papeleta || 0,
            aviso: 'Erro ao carregar'
          };
        }
      });

      // Aguarda todas as promises
      const resultados = await Promise.all(promises);

      // 🔥 ADICIONA TODOS OS RESULTADOS (inclusive os que têm marcacoes vazias)
      for (const resultado of resultados) {
        if (resultado) {
          dias.push(resultado);
        }
      }

      // Ordena por data (mais recente primeiro) e depois por papeleta
      this.diasApuradosCorrecao = dias.sort((a, b) => {
        const diffData = b.data.getTime() - a.data.getTime();
        if (diffData !== 0) return diffData;
        return (a.papeleta || 0) - (b.papeleta || 0);
      });

      console.log('📊 Dias carregados (incluindo vazios):', this.diasApuradosCorrecao.length);
      console.log('📊 Status no cache:', this.statusDias.size);

      this.filtrarDiasCorrecao('todos');
      this.calcularPaginacaoCorrecao();

    } catch (error) {
      console.error('Erro ao carregar dias apurados:', error);
      this.toastMessage = 'Erro ao carregar dados de correção.';
      this.showToast = true;
    } finally {
      this.isLoadingCorrecao = false;
      this.isLoadingStatus = false;
    }
  }*/

  async carregarDiasApurados(motorista: any) {
    try {
      this.isLoadingCorrecao = true;
      this.isLoadingStatus = true;

      this.limparDadosDaFolha(motorista.idFolhaServico);

      const hoje = new Date();
      const dataFim = hoje.toISOString().split('T')[0];
      const dataInicio = new Date(hoje);
      dataInicio.setDate(hoje.getDate() - 34);
      const dataInicioStr = dataInicio.toISOString().split('T')[0];

      console.log('Buscando folhas para motorista ID:', motorista.usuarioId);
      console.log('Período:', dataInicioStr, 'até', dataFim);

      const folhas = await this.folhaServicoService.buscarPorPeriodo(
        motorista.usuarioId,
        dataInicioStr,
        dataFim
      ).toPromise();

      console.log('Folhas encontradas:', folhas);

      if (!folhas || folhas.length === 0) {
        this.diasApuradosCorrecao = [];
        this.filtrarDiasCorrecao('todos');
        this.calcularPaginacaoCorrecao();
        this.toastMessage = 'Nenhuma folha de serviço encontrada neste período.';
        this.showToast = true;
        this.isLoadingCorrecao = false;
        this.isLoadingStatus = false;
        return;
      }

      // Limpa o cache antes de recarregar
      this.statusDias.clear();

      const dias: DiaApuradoCorrecao[] = [];

      // Usa Promise.all para carregar todos os status em paralelo
      const promises = folhas.map(async (folha) => {
        try {
          const response = await this.acertoHoraService.buscarAcertosPorFolhaServico(folha.id).toPromise();

          const data = new Date(folha.dataServico + 'T00:00:00');
          const papeleta = response?.papeleta || folha.papeleta || 0;

          // Filtra acertos não excluídos
          const acertosNaoExcluidos = (response?.acertos || []).filter((acerto: any) => {
            return !acerto.excluido && acerto.horaAcerto && acerto.horaAcerto.trim() !== '';
          });

          console.log(`Folha ${folha.id} - ${folha.dataServico} - Acertos:`, acertosNaoExcluidos.length);

          // Cria marcações
          const marcacoes: MarcacaoCorrecao[] = acertosNaoExcluidos.map((acerto: any) => ({
            hora: this.formatarHora(acerto.horaAcerto || ''),
            diferenca: 'Acerto',
            incompleta: false,
            acertoId: acerto.acertoId,
            motivo: acerto.motivoAcertoHoraId?.toString(),
            status: acerto.status,
            acertoData: acerto.dataAcerto || folha.dataServico,
            papeleta: papeleta
          }));

          // Ordena marcações
          marcacoes.sort((a, b) => {
            const horaExibicaoA = this.calcularHoraEstendida(
              a.hora || '00:00',
              a.acertoData || folha.dataServico,
              data
            );
            const horaExibicaoB = this.calcularHoraEstendida(
              b.hora || '00:00',
              b.acertoData || folha.dataServico,
              data
            );

            const minutosA = this.converterHoraEstendidaParaMinutos(horaExibicaoA);
            const minutosB = this.converterHoraEstendidaParaMinutos(horaExibicaoB);

            return minutosA - minutosB;
          });

          // Determina situações
          const situacoes: any[] = [];

          if (acertosNaoExcluidos.length === 0) {
            situacoes.push({
              tempo: '',
              descricao: 'Sem acertos - Clique em "Adicionar acerto" para incluir',
              tipo: 'info'
            });
          } else {
            const temPendente = acertosNaoExcluidos.some((a: any) => a.status === 'Pendente');
            const temAutorizado = acertosNaoExcluidos.some((a: any) => a.status === 'Autorizado');
            const temMarcado = acertosNaoExcluidos.some((a: any) => a.status === 'Marcado');
            const temRecusado = acertosNaoExcluidos.some((a: any) => a.status === 'Recusado');

            if (temPendente) {
              situacoes.push({ tempo: '', descricao: 'Acerto pendente', tipo: 'Pendente' });
            }
            if (temAutorizado) {
              situacoes.push({ tempo: '', descricao: 'Acerto autorizado', tipo: 'Autorizado' });
            }
            if (temMarcado) {
              situacoes.push({ tempo: '', descricao: 'Horário marcado', tipo: 'Marcado' });
            }
            if (temRecusado) {
              situacoes.push({ tempo: '', descricao: 'Acerto recusado', tipo: 'Recusado' });
            }
          }

          const dia: DiaApuradoCorrecao = {
            data: data,
            marcacoes: marcacoes,
            situacoes: situacoes,
            folhaServicoId: folha.id,
            papeleta: papeleta,
            aviso: acertosNaoExcluidos.length === 0 ? 'Sem acertos' : undefined
          };

          // Carrega o status e armazena no cache
          const status = await this.verificarStatusAssinaturaDia(
            folha.id,
            String(papeleta),
            data
          );

          const key = `${data.toISOString().split('T')[0]}_${papeleta}`;
          this.statusDias.set(key, status);
          console.log(`✅ Status carregado para ${key}:`, status);

          return dia;

        } catch (error) {
          console.error(`Erro ao carregar acertos da folha ${folha.id}:`, error);
          const data = new Date(folha.dataServico + 'T00:00:00');
          return {
            data: data,
            marcacoes: [],
            situacoes: [{ tempo: '', descricao: 'Erro ao carregar - clique em Adicionar acerto', tipo: 'erro' }],
            folhaServicoId: folha.id,
            papeleta: folha.papeleta || 0,
            aviso: 'Erro ao carregar'
          };
        }
      });

      // Aguarda todas as promises
      const resultados = await Promise.all(promises);

      // Adiciona todos os resultados
      for (const resultado of resultados) {
        if (resultado) {
          dias.push(resultado);
        }
      }

      // Ordena por data (mais recente primeiro)
      this.diasApuradosCorrecao = dias.sort((a, b) => {
        const diffData = b.data.getTime() - a.data.getTime();
        if (diffData !== 0) return diffData;
        return (a.papeleta || 0) - (b.papeleta || 0);
      });

      console.log('Dias carregados (incluindo vazios):', this.diasApuradosCorrecao.length);
      console.log('Status no cache:', this.statusDias.size);

      this.filtrarDiasCorrecao('todos');
      this.calcularPaginacaoCorrecao();

    } catch (error) {
      console.error('Erro ao carregar dias apurados:', error);
      this.toastMessage = 'Erro ao carregar dados de correção.';
      this.showToast = true;
    } finally {
      this.isLoadingCorrecao = false;
      this.isLoadingStatus = false;
    }
  }

  // Método para abrir o formulário de nova marcação
  /*abrirNovaMarcacao(dia: DiaApuradoCorrecao) {
    this.diaSelecionadoParaAdicionar = dia;
    this.novaMarcacao = { hora: '', motivoId: null };
    this.mostrarNovaMarcacao = true;
  }*/

  abrirNovaMarcacao(dia: DiaApuradoCorrecao) {
    this.diaSelecionadoParaAdicionar = dia;
    this.novaMarcacao = { hora: '', motivoId: null };
    this.mostrarNovaMarcacao = true;

    // 🔥 APÓS ABRIR, FOCA NO CAMPO DE HORA
    setTimeout(() => {
      const inputs = document.querySelectorAll('.input-hora-estendida');
      const inputsArray = Array.from(inputs);
      // Pega o primeiro input (que é o novo)
      const primeiroInput = inputsArray[0] as HTMLInputElement;
      if (primeiroInput && !primeiroInput.disabled) {
        primeiroInput.focus();
        primeiroInput.select();
        primeiroInput.classList.add('hora-focus');

        // Remove a classe dos outros campos
        inputsArray.forEach((input: Element) => {
          const el = input as HTMLInputElement;
          if (el !== primeiroInput) {
            el.classList.remove('hora-focus');
          }
        });
      }
    }, 150);
  }

  private focarPrimeiroCampoHoraCorrecao() {
    const inputs = document.querySelectorAll('.input-hora-estendida');
    const inputsArray = Array.from(inputs);
    for (const input of inputsArray) {
      const elemento = input as HTMLInputElement;
      if (!elemento.disabled) {
        elemento.focus();
        elemento.select();
        elemento.classList.add('hora-focus');
        break;
      }
    }
  }

  // Fechar formulário de nova marcação
  fecharNovaMarcacao() {
    this.mostrarNovaMarcacao = false;
    this.diaSelecionadoParaAdicionar = null;
    this.novaMarcacao = { hora: '', motivoId: null };
  }

  async salvarNovaMarcacao() {
    if (!this.diaSelecionadoParaAdicionar) return;

    this.novaMarcacao.hora = this.normalizarHora(this.novaMarcacao.hora);

    if (!this.novaMarcacao.hora) {
      this.toastMessage = 'Hora é obrigatória.';
      this.showToast = true;
      return;
    }

    // Valida a hora estendida
    if (!this.validarHoraEstendida(this.novaMarcacao.hora)) {
      this.toastMessage = 'Hora inválida. Use formato HH:mm (00:00 a 47:59)';
      this.showToast = true;
      return;
    }

    if (!this.novaMarcacao.motivoId) {
      this.toastMessage = 'Selecione um motivo para o acerto.';
      this.showToast = true;
      return;
    }

    this.isLoadingCorrecao = true;

    try {
      // Converte a hora estendida para hora normal e ajusta a data
      const dataReferencia = this.diaSelecionadoParaAdicionar.data;
      const { hora: horaConvertida, data: novaData } = this.converterHoraComData(
        this.novaMarcacao.hora,
        dataReferencia
      );

      let veiculo = null;

      // 1. Tenta buscar via buscarAcertosPorFolhaServico (retorna numeroVeiculo)
      if (this.diaSelecionadoParaAdicionar && this.diaSelecionadoParaAdicionar.folhaServicoId) {
        try {
          const response = await this.acertoHoraService.buscarAcertosPorFolhaServico(
            this.diaSelecionadoParaAdicionar.folhaServicoId
          ).toPromise();

          // 🔥 O veículo vem como numeroVeiculo no response
          if (response && response.numeroVeiculo) {
            veiculo = parseInt(response.numeroVeiculo, 10);
            console.log('✅ Veículo encontrado via buscarAcertosPorFolhaServico:', veiculo);
          } else {
            console.log('⚠️ response.numeroVeiculo é null ou undefined:', response);
          }
        } catch (error) {
          console.warn('Erro ao buscar veículo da folha:', error);
        }
      }

      const novoAcerto: AcertoHoraDTO = {
        hora: horaConvertida,
        motivoAcertoHoraId: this.novaMarcacao.motivoId,
        usuario: this.motoristaParaAssinar?.matricula?.toString(),
        folhaServicoId: this.diaSelecionadoParaAdicionar.folhaServicoId,
        statusAcertoHora: 'Pendente',
        excluido: false,
        data: novaData.toISOString().split('T')[0],
        offline: !(await Network.getStatus()).connected,
        coletorMarcacao: this.getColetorMarcacao(),
        veiculo: veiculo
      };

      console.log('Salvando novo acerto:', novoAcerto);

      await this.acertoHoraService.salvar([novoAcerto]).toPromise();

      this.toastMessage = 'Acerto adicionado com sucesso!';
      this.showToast = true;

      // Recarrega os dados
      await this.carregarDiasApurados(this.motoristaParaAssinar);

      if (this.motoristaParaAssinar) {
        this.carregarAcertosHorarios(
          this.motoristaParaAssinar.idFolhaServico,
          this.motoristaParaAssinar.usuarioId
        );
      }

      this.fecharNovaMarcacao();

    } catch (error) {
      console.error('Erro ao adicionar acerto:', error);
      this.toastMessage = this.extrairMensagemErro(error, 'Erro ao adicionar acerto.');
      this.showToast = true;
    } finally {
      this.isLoadingCorrecao = false;
    }
  }

  filtrarDiasCorrecao(filtro: 'todos' | 'pendentes') {
    this.filtroAtualCorrecao = filtro;
    this.paginaAtualCorrecao = 1;

    if (filtro === 'todos') {
      this.diasFiltradosCorrecao = [...this.diasApuradosCorrecao];
    } else {
      this.diasFiltradosCorrecao = this.diasApuradosCorrecao.filter(dia =>
        dia.situacoes.some(s => s.tipo === 'Pendente')
      );
    }

    this.calcularPaginacaoCorrecao();
  }

  calcularPaginacaoCorrecao(): void {
    this.totalPaginasCorrecao = Math.ceil(this.diasFiltradosCorrecao.length / this.itensPorPaginaCorrecao);
    if (this.totalPaginasCorrecao === 0) this.totalPaginasCorrecao = 1;
  }

  paginaAnteriorCorrecao(): void {
    if (this.paginaAtualCorrecao > 1) {
      this.paginaAtualCorrecao--;
    }
  }

  proximaPaginaCorrecao(): void {
    if (this.paginaAtualCorrecao < this.totalPaginasCorrecao) {
      this.paginaAtualCorrecao++;
    }
  }

  getDiasPaginadosCorrecao(): DiaApuradoCorrecao[] {
    const inicio = (this.paginaAtualCorrecao - 1) * this.itensPorPaginaCorrecao;
    return this.diasFiltradosCorrecao.slice(inicio, inicio + this.itensPorPaginaCorrecao);
  }

  getDiaSemana(data: Date): string {
    const dias = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
    return dias[data.getDay()];
  }

  get totalDiasCorrecao(): number {
    return this.diasApuradosCorrecao.length;
  }

  get diasPendentesCorrecao(): number {
    return this.diasApuradosCorrecao.filter(d =>
      d.situacoes.some(s => s.tipo === 'Pendente')
    ).length;
  }

  // Iniciar edição de um acerto
  iniciarEdicaoAcerto(acertoId: number, horaAtual: string, motivoId?: number, acertoData?: string) {
    this.editandoAcertoId = acertoId;
    this.acertoEditando = {
      hora: horaAtual,
      motivoId: motivoId
    };
    this.acertoEditandoData = acertoData || null;
  }

  // Cancelar edição
  cancelarEdicaoAcerto() {
    this.editandoAcertoId = null;
    this.acertoEditando = null;
  }

  async salvarEdicaoAcerto(dia: DiaApuradoCorrecao, marcacao: MarcacaoCorrecao) {
    if (!this.acertoEditando || !this.acertoEditando.hora) {
      this.toastMessage = 'Hora é obrigatória.';
      this.showToast = true;
      return;
    }

    this.acertoEditando.hora = this.normalizarHora(this.acertoEditando.hora);

    // Valida a hora estendida
    if (!this.validarHoraEstendida(this.acertoEditando.hora)) {
      this.toastMessage = 'Hora inválida. Use formato HH:mm (00:00 a 47:59)';
      this.showToast = true;
      return;
    }

    if (!this.acertoEditando.motivoId) {
      this.toastMessage = 'Selecione um motivo para o acerto.';
      this.showToast = true;
      return;
    }

    this.isLoadingCorrecao = true;

    try {
      // Converte a hora estendida para hora normal e ajusta a data
      const dataReferencia = dia.data;
      const { hora: horaConvertida, data: novaData } = this.converterHoraComData(
        this.acertoEditando.hora,
        dataReferencia
      );

      const acertoAtualizado: AcertoHoraDTO = {
        id: marcacao.acertoId,
        hora: horaConvertida,
        motivoAcertoHoraId: this.acertoEditando.motivoId,
        usuario: this.motoristaParaAssinar?.matricula?.toString(),
        folhaServicoId: dia.folhaServicoId,
        statusAcertoHora: 'Pendente',
        excluido: false,
        data: novaData.toISOString().split('T')[0],
        offline: !(await Network.getStatus()).connected,
        coletorMarcacao: this.getColetorMarcacao()
      };

      console.log('Atualizando acerto:', acertoAtualizado);

      await this.acertoHoraService.salvar([acertoAtualizado]).toPromise();

      this.toastMessage = 'Acerto atualizado com sucesso!';
      this.showToast = true;

      await this.carregarDiasApurados(this.motoristaParaAssinar);

      if (this.motoristaParaAssinar) {
        this.carregarAcertosHorarios(
          this.motoristaParaAssinar.idFolhaServico,
          this.motoristaParaAssinar.usuarioId
        );
      }

    } catch (error) {
      console.error('Erro ao salvar acerto:', error);
      this.toastMessage = 'Erro ao salvar alteração.';
      this.showToast = true;
    } finally {
      this.isLoadingCorrecao = false;
      this.cancelarEdicaoAcerto();
    }
  }

  public formatarHoraExibicao(hora: string | undefined): string {
    if (!hora) return '';
    return hora.substring(0, 5);
  }

  // Excluir acerto
  async excluirAcerto(dia: DiaApuradoCorrecao, marcacao: MarcacaoCorrecao) {
    const alert = await this.alertController.create({
      header: 'Confirmar exclusão',
      message: `Tem certeza que deseja excluir o acerto das ${marcacao.hora}?`,
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        {
          text: 'Excluir',
          handler: async () => {
            this.isLoadingCorrecao = true;
            try {
              const acertoExcluido: AcertoHoraDTO = {
                id: marcacao.acertoId,
                excluido: true, // Marca como excluído
                usuario: this.motoristaParaAssinar?.matricula?.toString(),
                folhaServicoId: dia.folhaServicoId,
                offline: !(await Network.getStatus()).connected,
                coletorMarcacao: this.getColetorMarcacao()
              };

              console.log('Excluindo acerto:', acertoExcluido);

              await this.acertoHoraService.salvar([acertoExcluido]).toPromise();

              this.toastMessage = 'Acerto excluído com sucesso!';
              this.showToast = true;

              // Recarrega os dados para remover o acerto da lista
              await this.carregarDiasApurados(this.motoristaParaAssinar);

              // Recarrega os acertos na tela principal
              if (this.motoristaParaAssinar) {
                this.carregarAcertosHorarios(
                  this.motoristaParaAssinar.idFolhaServico,
                  this.motoristaParaAssinar.usuarioId
                );
              }

            } catch (error) {
              console.error('Erro ao excluir acerto:', error);
              this.toastMessage = 'Erro ao excluir acerto.';
              this.showToast = true;
            } finally {
              this.isLoadingCorrecao = false;
            }
          }
        }
      ]
    });
    await alert.present();
  }

  getJustificativaDescricao(motivoId?: string): string {
    if (!motivoId) return '';
    const motivo = this.motivosDisponiveis.find(m => m.id.toString() === motivoId);
    return motivo ? motivo.descricao : '';
  }

  verificarStatusJornada(motorista: MotoristaJornadaDTO): boolean {
    // Filtra os acertos deste motorista que NÃO estão excluídos
    const acertosValidos = this.acertosHorarios.filter(acerto =>
      acerto.folhaServicoId === motorista.idFolhaServico &&
      !acerto.excluido
    );

    return acertosValidos.length % 2 !== 0;
  }

  private formatarHora(hora: string): string {
    if (!hora) return '';
    return hora.substring(0, 5);
  }

  deveMostrarIniciar(motorista: MotoristaJornadaDTO): boolean {
    // Pega acertos do banco
    const acertosBanco = this.acertosHorarios.filter(
      acerto => acerto.folhaServicoId === motorista.idFolhaServico && !acerto.excluido
    );

    // Pega acertos temporários
    const acertosTemp = this.horariosTemporarios[motorista.idFolhaServico] || [];

    // Total = banco + temporários
    const totalAcertos = acertosBanco.length + acertosTemp.length;

    // Se for PAR mostra INICIAR, se for ÍMPAR mostra FINALIZAR
    return totalAcertos % 2 === 0;
  }

  async assinarPapeletaDoDia(dia: DiaApuradoCorrecao) {
    if (!this.motoristaParaAssinar) {
      this.toastMessage = 'Motorista não identificado!';
      this.showToast = true;
      return;
    }

    if (!dia.folhaServicoId) {
      this.toastMessage = 'ID da folha de serviço não encontrado!';
      this.showToast = true;
      return;
    }

    const loading = await this.alertController.create({
      message: 'Gerando papeleta assinada...',
      backdropDismiss: false
    });
    await loading.present();

    const dataServico = dia.data.toISOString().split('T')[0];

    // 🔥 CORREÇÃO: Adiciona o folhaServicoId
    this.relatorioService
      .gerarPdfPapeleta(this.motoristaParaAssinar.matricula, dataServico, true, dia.folhaServicoId)
      .subscribe({
        next: (blob: Blob) => {
          loading.dismiss();
          const url = window.URL.createObjectURL(blob);
          window.open(url, '_blank');
          this.toastMessage = `Papeleta do dia ${dataServico} assinada com sucesso!`;
          this.showToast = true;
        },
        error: (error) => {
          loading.dismiss();
          console.error('Erro ao gerar PDF:', error);
          if (error && error.erro) {
            this.toastMessage = error.erro;
          } else {
            this.toastMessage = 'Erro ao gerar a papeleta assinada.';
          }
          this.showToast = true;
        }
      });
  }

  /*solicitarExclusaoAssinatura(motorista: any) {
    if (!this.tokenAutenticacao) {
      this.toastMessage = 'Faça login primeiro!';
      this.showToast = true;
      return;
    }

    this.alertController.create({
      header: 'Confirmar exclusão',
      message: `Tem certeza que deseja solicitar a exclusão da assinatura da papeleta ${motorista.papeleta}?`,
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        {
          text: 'Confirmar',
          handler: async () => {
            this.webSocketService.solicitarExclusaoAssinatura({
              numeroPapeleta: motorista.papeleta,
              nomeMotorista: motorista.nome,
              matricula: motorista.matricula,
              usuario: motorista.matricula,
              folhaServicoId: motorista.idFolhaServico
            });

            this.toastMessage = 'Solicitação de exclusão enviada com sucesso!';
            this.showToast = true;

            this.limparDadosMotorista();

            // 🔥 RECARREGA OS DADOS DO MOTORISTA (substitui os antigos)
            await this.carregarDadosMotoristaCompleto(motorista.matricula);

            // 🔥 FORÇA ATUALIZAÇÃO DA TELA
            this.cdr.detectChanges();

            await this.recarregarMotoristaAtual();

            if (this.mostrarModalCorrecao && this.motoristaParaAssinar) {
              await this.carregarDiasApurados(this.motoristaParaAssinar);
            }

            this.cdr.detectChanges();
          }
        }
      ]
    }).then(alert => alert.present());
  }*/

  solicitarExclusaoAssinatura(motorista: any) {
    if (!this.tokenAutenticacao) {
      this.toastMessage = 'Faça login primeiro!';
      this.showToast = true;
      return;
    }

    this.alertController.create({
      header: 'Confirmar exclusão',
      message: `Tem certeza que deseja excluir a assinatura da papeleta ${motorista.papeleta}?`,
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        {
          text: 'Confirmar',
          handler: async () => {
            this.isLoadingCorrecao = true;
            try {
              // Envia a solicitação via WebSocket (backend processa direto)
              this.webSocketService.solicitarExclusaoAssinatura({
                numeroPapeleta: String(motorista.papeleta),
                nomeMotorista: motorista.nome,
                matricula: String(motorista.matricula),
                usuario: String(motorista.matricula),
                folhaServicoId: motorista.idFolhaServico
              });

              this.toastMessage = 'Assinatura excluída com sucesso!';
              this.showToast = true;

              // Limpa e recarrega os dados do motorista
              await this.limparDadosMotorista();
              await this.carregarDadosMotoristaCompleto(motorista.matricula);

              // Se o modal de correção estiver aberto, recarrega os dias
              if (this.mostrarModalCorrecao && this.motoristaParaAssinar) {
                await this.carregarDiasApurados(this.motoristaParaAssinar);
              }

              this.cdr.detectChanges();
            } catch (error) {
              console.error('Erro ao excluir assinatura:', error);
              this.toastMessage = 'Erro ao excluir assinatura.';
              this.showToast = true;
            } finally {
              this.isLoadingCorrecao = false;
            }
          }
        }
      ]
    }).then(alert => alert.present());
  }

  // Método para formatar hora automaticamente (aceita até 47:59)
  formatarHoraEstendida(event: any): void {
    let valor = event.target.value;
    // Remove tudo que não é número
    valor = valor.replace(/\D/g, '');

    // Permite até 5 caracteres (HHmm ou HHHmm para horas > 24)
    const maxLength = 5;
    if (valor.length > maxLength) {
      valor = valor.substring(0, maxLength);
    }

    // Adiciona os dois pontos automaticamente
    if (valor.length >= 3) {
      const horas = valor.substring(0, valor.length - 2);
      const minutos = valor.substring(valor.length - 2);
      valor = `${horas}:${minutos}`;
    }

    if (this.acertoEditando) {
      this.acertoEditando.hora = valor;
    }
  }

  // Valida hora (permite 00:00 até 47:59)
  validarHoraEstendida(hora: string): boolean {
    if (!hora || !hora.includes(':')) return false;

    const [horasStr, minutosStr] = hora.split(':');
    const horas = parseInt(horasStr, 10);
    const minutos = parseInt(minutosStr, 10);

    if (isNaN(horas) || isNaN(minutos)) return false;
    if (horas < 0 || horas > 47) return false;
    if (minutos < 0 || minutos > 59) return false;

    return true;
  }

  // Converte hora no formato HH:mm ou H+ (ex: 25:00) para hora e data corretas
  private converterHoraComData(horaStr: string, dataBase: Date): { hora: string, data: Date } {
    if (!horaStr || !horaStr.includes(':')) {
      return { hora: horaStr, data: dataBase };
    }

    const [horasStr, minutosStr] = horaStr.split(':');
    let horas = parseInt(horasStr, 10);
    const minutos = parseInt(minutosStr, 10);

    // Se hora for >= 24, ajusta para o próximo dia
    if (horas >= 24) {
      const diasAdicionar = Math.floor(horas / 24);
      horas = horas % 24;

      const novaData = new Date(dataBase);
      novaData.setDate(dataBase.getDate() + diasAdicionar);

      const horaFormatada = `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`;
      return { hora: horaFormatada, data: novaData };
    }

    return { hora: horaStr, data: dataBase };
  }

  // Formata hora para exibição (converte 02:00 do dia 16 para 26:00)
  public formatarHoraParaExibicao(hora: string, dataAcerto: string | Date, dataReferencia: Date): string {
    if (!hora) return '';

    const dataAcertoObj = typeof dataAcerto === 'string'
      ? new Date(dataAcerto + 'T00:00:00')
      : dataAcerto;

    const dataReferenciaObj = new Date(dataReferencia);
    dataReferenciaObj.setHours(0, 0, 0, 0);

    if (dataAcertoObj > dataReferenciaObj) {
      const diffDias = Math.floor((dataAcertoObj.getTime() - dataReferenciaObj.getTime()) / (1000 * 60 * 60 * 24));
      if (diffDias > 0) {
        const [horas, minutos] = hora.split(':');
        const novaHora = (parseInt(horas, 10) + (diffDias * 24)).toString().padStart(2, '0');
        return `${novaHora}:${minutos}`;
      }
    }

    return hora;
  }

  formatarHoraEstendidaNova(event: any): void {
    let valor = event.target.value;
    // Remove tudo que não é número
    valor = valor.replace(/\D/g, '');

    // Permite até 5 caracteres (HHmm ou HHHmm para horas > 24)
    const maxLength = 5;
    if (valor.length > maxLength) {
      valor = valor.substring(0, maxLength);
    }

    // Adiciona os dois pontos automaticamente
    if (valor.length >= 3) {
      const horas = valor.substring(0, valor.length - 2);
      const minutos = valor.substring(valor.length - 2);
      valor = `${horas}:${minutos}`;
    }

    this.novaMarcacao.hora = valor;
  }

  temAssinatura(motorista: any): boolean {
    const temAssinatura = motorista.dataHoraAssinatura != null &&
      motorista.dataHoraAssinatura !== '' &&
      motorista.dataHoraAssinatura !== 'null';

    console.log(`🔍 Verificando assinatura para ${motorista.nome}:`, temAssinatura);
    return temAssinatura;
  }

  async recarregarMotoristaAtual() {
    if (!this.motoristas.length) return;

    const matricula = this.motoristas[0].matricula;

    return new Promise<void>((resolve) => {
      this.motoristaService.listarMotoristas().subscribe({
        next: (data) => {
          const motoristaAtualizado = data.find(m => m.matricula === matricula);

          if (motoristaAtualizado) {
            // Atualiza o motorista existente
            this.motoristas = [motoristaAtualizado];
            this.motoristasFiltrados = [motoristaAtualizado];

            // 🔥 Usa o método que substitui os dados
            this.carregarAcertosHorariosSubstituindo(
              motoristaAtualizado.idFolhaServico,
              motoristaAtualizado.usuarioId
            );

            this.cdr.detectChanges();
          }
          resolve();
        },
        error: (err) => {
          console.error('Erro ao recarregar motorista:', err);
          resolve();
        }
      });
    });
  }

  async confirmarAssinatura() {
    if (!this.motoristaParaAssinar) {
      this.cancelarAssinatura();
      return;
    }

    const validacao = this.podeAssinarPapeleta(this.motoristaParaAssinar);

    if (!validacao.pode) {
      this.toastMessage = validacao.mensagem;
      this.showToast = true;
      this.motoristaParaAssinar = null;
      this.mostrarConfirmacaoAssinatura = false;
      return;
    }

    const matricula = this.motoristaParaAssinar.matricula;
    const papeleta = this.motoristaParaAssinar.papeleta;
    const dataServico = this.motoristaParaAssinar.dataServico.split('T')[0];
    const folhaServicoId = this.motoristaParaAssinar.idFolhaServico;

    if (!folhaServicoId) {
      this.toastMessage = 'ID da folha de serviço não encontrado!';
      this.showToast = true;
      this.motoristaParaAssinar = null;
      this.mostrarConfirmacaoAssinatura = false;
      return;
    }

    console.log('📝 Iniciando assinatura para:', { matricula, papeleta, folhaServicoId });

    this.mostrarConfirmacaoAssinatura = false;

    const loading = await this.alertController.create({
      message: 'Assinando papeleta...',
      backdropDismiss: false
    });
    await loading.present();

    // 🔥 PASSA O FOLHA_SERVICO_ID
    this.relatorioService.gerarPdfPapeleta(matricula, dataServico, true, folhaServicoId).subscribe({
      next: async (blob: Blob) => {
        loading.dismiss();
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');

        this.webSocketService.registrarAssinatura({
          numeroPapeleta: papeleta,
          usuario: matricula.toString(),
          //folhaServicoId: folhaServicoId  // 🔥 ENVIA O ID PELO WEBSOCKET
        });

        await this.delay(2000);
        await this.recarregarMotoristaAtual();
        this.cdr.detectChanges();

        this.toastMessage = 'Papeleta assinada com sucesso!';
        this.showToast = true;
        this.motoristaParaAssinar = null;
      },
      error: async (error: any) => {
        loading.dismiss();
        console.error('Erro na assinatura:', error);

        let mensagemErro = 'Erro ao gerar a papeleta assinada.';

        if (error && error.erro) {
          mensagemErro = error.erro;
        } else if (error && error.mensagem) {
          mensagemErro = error.mensagem;
        } else if (error && error.message) {
          mensagemErro = error.message;
        } else if (typeof error === 'string') {
          mensagemErro = error;
        }

        this.toastMessage = mensagemErro;
        this.showToast = true;
        this.motoristaParaAssinar = null;
      }
    });
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  /*async verificarStatusAssinaturaDia(folhaServicoId: number, papeleta: string, data: Date): Promise<StatusAssinaturaDia> {
    try {
      // 🔥 CORREÇÃO: Usa o folhaServicoId passado como parâmetro, não outro ID
      console.log('🔍 Verificando status para folha:', folhaServicoId);

      // Busca os acertos da folha para verificar se está assinada
      const acertosData = await this.acertoHoraService.buscarAcertosPorFolhaServico(folhaServicoId).toPromise();
      const jaAssinada = acertosData?.dataHoraAssinatura != null;

      console.log('📝 Folha assinada?', jaAssinada);

      // Se não está assinada, permite assinar
      if (!jaAssinada) {
        return {
          podeAssinar: true,
          podeSolicitarExclusao: false,
          statusSolicitacao: null,
          textoBotao: 'Assinar Papeleta',
          corBotao: 'success',
          desabilitado: false,
          mensagem: ''
        };
      }

      // 🔥 CORREÇÃO: Usa o folhaServicoId na busca do histórico
      const historico = await this.webSocketService.buscarHistoricoPorFolha(folhaServicoId);

      if (historico && historico.length > 0) {
        const ordenado = historico.sort((a, b) =>
          new Date(b.dataHoraSolicitacao || '').getTime() - new Date(a.dataHoraSolicitacao || '').getTime()
        );

        const ultimaSolicitacao = ordenado[0];
        console.log(`Última solicitação da folha ${folhaServicoId}:`, ultimaSolicitacao);

        if (ultimaSolicitacao.tipoMarcacao === 'EXCLUSAO' && ultimaSolicitacao.status === 'PENDENTE') {
          return {
            podeAssinar: false,
            podeSolicitarExclusao: false,
            statusSolicitacao: 'PENDENTE',
            textoBotao: 'Aguardando Exclusão',
            corBotao: 'warning',
            desabilitado: true,
            mensagem: 'Já existe uma solicitação de exclusão pendente para este dia. Aguarde a análise.'
          };
        }

        if (ultimaSolicitacao.tipoMarcacao === 'AUTORIZACAO' && ultimaSolicitacao.status === 'ACEITA') {
          return {
            podeAssinar: true,
            podeSolicitarExclusao: false,
            statusSolicitacao: 'ACEITA',
            textoBotao: 'Assinar Papeleta',
            corBotao: 'success',
            desabilitado: false,
            mensagem: ''
          };
        }

        if (ultimaSolicitacao.tipoMarcacao === 'AUTORIZACAO' && ultimaSolicitacao.status === 'NEGADA') {
          return {
            podeAssinar: false,
            podeSolicitarExclusao: true,
            statusSolicitacao: 'NEGADA',
            textoBotao: 'Solicitar Exclusão',
            corBotao: 'danger',
            desabilitado: false,
            mensagem: 'Solicitação anterior foi negada. Você pode solicitar novamente.'
          };
        }
      }

      return {
        podeAssinar: false,
        podeSolicitarExclusao: true,
        statusSolicitacao: null,
        textoBotao: 'Solicitar Exclusão',
        corBotao: 'danger',
        desabilitado: false,
        mensagem: ''
      };

    } catch (error) {
      console.error('Erro ao verificar status do dia:', error);
      return {
        podeAssinar: false,
        podeSolicitarExclusao: false,
        statusSolicitacao: null,
        textoBotao: 'Erro',
        corBotao: 'medium',
        desabilitado: true,
        mensagem: 'Erro ao carregar status'
      };
    }
  }*/

  async verificarStatusAssinaturaDia(folhaServicoId: number, papeleta: string, data: Date): Promise<StatusAssinaturaDia> {
    try {
      // Busca os acertos da folha para verificar se está assinada
      const acertosData = await this.acertoHoraService.buscarAcertosPorFolhaServico(folhaServicoId).toPromise();
      const jaAssinada = acertosData?.dataHoraAssinatura != null;

      console.log(`📝 Verificando assinatura para folha ${folhaServicoId}:`, jaAssinada);

      // Se NÃO está assinada, permite assinar
      if (!jaAssinada) {
        return {
          podeAssinar: true,
          podeSolicitarExclusao: false,
          statusSolicitacao: null,
          textoBotao: 'Assinar Papeleta',
          corBotao: 'success',
          desabilitado: false,
          mensagem: ''
        };
      }

      return {
        podeAssinar: false,
        podeSolicitarExclusao: true,
        statusSolicitacao: null,
        textoBotao: 'Excluir assinatura',
        corBotao: 'danger',
        desabilitado: false,
        mensagem: 'Clique para excluir a assinatura diretamente'
      };

    } catch (error) {
      console.error('Erro ao verificar status do dia:', error);
      return {
        podeAssinar: false,
        podeSolicitarExclusao: false,
        statusSolicitacao: null,
        textoBotao: 'Erro',
        corBotao: 'medium',
        desabilitado: true,
        mensagem: 'Erro ao carregar status'
      };
    }
  }

  /*getStatusDia(dia: DiaApuradoCorrecao): StatusAssinaturaDia {
    // 🔥 USA A PAPELETA DO DIA, NÃO DO MOTORISTA
    const key = `${dia.data.toISOString().split('T')[0]}_${dia.papeleta || ''}`;

    const status = this.statusDias.get(key);

    if (status) {
      return status;
    }

    // Status padrão enquanto não carregado
    return {
      podeAssinar: false,
      podeSolicitarExclusao: false,
      statusSolicitacao: null,
      textoBotao: 'Carregando...',
      corBotao: 'medium',
      desabilitado: true,
      mensagem: 'Carregando status...'
    };
  }*/

  getStatusDia(dia: DiaApuradoCorrecao): StatusAssinaturaDia {
    // Usa a papeleta do dia
    const key = `${dia.data.toISOString().split('T')[0]}_${dia.papeleta || ''}`;

    const status = this.statusDias.get(key);

    if (status) {
      return status;
    }

    return {
      podeAssinar: false,
      podeSolicitarExclusao: false,
      statusSolicitacao: null,
      textoBotao: 'Carregando...',
      corBotao: 'medium',
      desabilitado: true,
      mensagem: 'Carregando status...'
    };
  }

  /*async acaoPapeletaDoDia(dia: DiaApuradoCorrecao) {
    if (!this.motoristaParaAssinar) {
      this.toastMessage = 'Motorista não identificado!';
      this.showToast = true;
      return;
    }

    const status = this.getStatusDia(dia);

    if (status.desabilitado) {
      if (status.mensagem) {
        this.toastMessage = status.mensagem;
        this.showToast = true;
      }
      return;
    }

    if (status.podeAssinar) {
      // Abre popup de confirmação de assinatura
      this.diaParaAssinar = dia;
      this.mostrarConfirmacaoAssinatura = true;
    } else if (status.podeSolicitarExclusao) {
      // Solicita exclusão diretamente
      this.solicitarExclusaoAssinaturaDia(dia);
    }
  }*/

  async acaoPapeletaDoDia(dia: DiaApuradoCorrecao) {
    if (!this.motoristaParaAssinar) {
      this.toastMessage = 'Motorista não identificado!';
      this.showToast = true;
      return;
    }

    const status = this.getStatusDia(dia);

    if (status.desabilitado) {
      if (status.mensagem) {
        this.toastMessage = status.mensagem;
        this.showToast = true;
      }
      return;
    }

    if (status.podeAssinar) {
      // Abre popup de confirmação de assinatura
      this.diaParaAssinar = dia;
      this.mostrarConfirmacaoAssinatura = true;
    } else if (status.podeSolicitarExclusao) {
      // Solicita exclusão direta (sem pendência)
      this.solicitarExclusaoAssinaturaDireta(dia);
    }
  }

  solicitarExclusaoAssinaturaDireta(dia: DiaApuradoCorrecao) {
    if (!this.motoristaParaAssinar) return;

    const dataExibicao = dia.data.toLocaleDateString('pt-BR');

    this.alertController.create({
      header: 'Confirmar exclusão',
      message: `Tem certeza que deseja excluir a assinatura da papeleta do dia ${dataExibicao}?`,
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        {
          text: 'Confirmar',
          handler: async () => {
            this.isLoadingCorrecao = true;
            try {
              // Envia a solicitação via WebSocket (backend processa direto)
              this.webSocketService.solicitarExclusaoAssinatura({
                numeroPapeleta: String(this.motoristaParaAssinar.papeleta),
                nomeMotorista: this.motoristaParaAssinar.nome,
                matricula: String(this.motoristaParaAssinar.matricula),
                usuario: String(this.motoristaParaAssinar.matricula),
                folhaServicoId: dia.folhaServicoId
              });

              this.toastMessage = 'Assinatura excluída com sucesso!';
              this.showToast = true;

              // Recarrega os dados
              await this.carregarDiasApurados(this.motoristaParaAssinar);

              if (this.motoristaParaAssinar) {
                this.carregarAcertosHorarios(
                  this.motoristaParaAssinar.idFolhaServico,
                  this.motoristaParaAssinar.usuarioId
                );
              }

              this.cdr.detectChanges();
            } catch (error) {
              console.error('Erro ao excluir assinatura:', error);
              this.toastMessage = 'Erro ao excluir assinatura.';
              this.showToast = true;
            } finally {
              this.isLoadingCorrecao = false;
            }
          }
        }
      ]
    }).then(alert => alert.present());
  }

  async confirmarAssinaturaDia() {
    if (!this.diaParaAssinar || !this.motoristaParaAssinar) {
      this.cancelarAssinaturaDia();
      return;
    }

    const validacao = this.podeAssinarPapeletaDoDia(this.diaParaAssinar);

    if (!validacao.pode) {
      this.toastMessage = validacao.mensagem;
      this.showToast = true;
      this.diaParaAssinar = null;
      this.mostrarConfirmacaoAssinatura = false;
      return;
    }

    const matricula = this.motoristaParaAssinar.matricula;
    const papeleta = this.motoristaParaAssinar.papeleta;
    const dataServico = this.diaParaAssinar.data.toISOString().split('T')[0];
    const folhaServicoId = this.diaParaAssinar.folhaServicoId; // 🔥 PEGA O ID DO DIA

    if (!folhaServicoId) {
      this.toastMessage = 'ID da folha de serviço não encontrado!';
      this.showToast = true;
      this.diaParaAssinar = null;
      this.mostrarConfirmacaoAssinatura = false;
      return;
    }

    this.mostrarConfirmacaoAssinatura = false;

    const loading = await this.alertController.create({
      message: 'Assinando papeleta...',
      backdropDismiss: false
    });
    await loading.present();

    // 🔥 PASSA O FOLHA_SERVICO_ID
    this.relatorioService.gerarPdfPapeleta(matricula, dataServico, true, folhaServicoId).subscribe({
      next: async (blob: Blob) => {
        loading.dismiss();
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');

        this.webSocketService.registrarAssinatura({
          numeroPapeleta: String(papeleta),
          usuario: String(matricula),
          //folhaServicoId: folhaServicoId  
        });

        await this.delay(2000);
        await this.carregarDiasApurados(this.motoristaParaAssinar);

        if (this.motoristaParaAssinar) {
          this.carregarAcertosHorarios(
            this.motoristaParaAssinar.idFolhaServico,
            this.motoristaParaAssinar.usuarioId
          );
        }

        this.cdr.detectChanges();

        this.toastMessage = `Papeleta do dia ${dataServico} assinada com sucesso!`;
        this.showToast = true;
        this.diaParaAssinar = null;
      },
      error: (error: any) => {
        loading.dismiss();
        console.error('Erro ao gerar PDF:', error);

        // 🔥🔥🔥 PRIORIDADE MÁXIMA PARA error.erro 🔥🔥🔥
        let mensagemErro = 'Erro ao gerar a papeleta assinada.';

        if (error && error.erro) {
          mensagemErro = error.erro;
        } else if (error && error.mensagem) {
          mensagemErro = error.mensagem;
        } else if (error && error.message) {
          mensagemErro = error.message;
        } else if (typeof error === 'string') {
          mensagemErro = error;
        }

        this.toastMessage = mensagemErro;
        this.showToast = true;
        this.diaParaAssinar = null;
      }
    });
  }

  solicitarExclusaoAssinaturaDia(dia: DiaApuradoCorrecao) {
    if (!this.motoristaParaAssinar) return;

    const dataExibicao = dia.data.toLocaleDateString('pt-BR');

    this.alertController.create({
      header: 'Confirmar exclusão',
      message: `Tem certeza que deseja solicitar a exclusão da assinatura da papeleta do dia ${dataExibicao}?`,
      buttons: [
        { text: 'Cancelar', role: 'cancel' },
        {
          text: 'Confirmar',
          handler: async () => {
            // Envia o folhaServicoId junto com a solicitação
            this.webSocketService.solicitarExclusaoAssinatura({
              numeroPapeleta: String(this.motoristaParaAssinar.papeleta),
              nomeMotorista: this.motoristaParaAssinar.nome,
              matricula: String(this.motoristaParaAssinar.matricula),
              usuario: String(this.motoristaParaAssinar.matricula),
              folhaServicoId: dia.folhaServicoId
            });

            this.toastMessage = 'Solicitação de exclusão enviada com sucesso!';
            this.showToast = true;

            // Recarrega os status
            await this.carregarDiasApurados(this.motoristaParaAssinar);
            this.cdr.detectChanges();
          }
        }
      ]
    }).then(alert => alert.present());
  }

  cancelarAssinaturaDia() {
    this.mostrarConfirmacaoAssinatura = false;
    this.diaParaAssinar = null;
  }

  // Método para iniciar papeleta em branco
  async iniciarPapeletaEmBranco() {
    if (!this.tokenAutenticacao) {
      this.toastMessage = 'Faça login primeiro!';
      this.showToast = true;
      return;
    }

    if (!this.motoristas.length) {
      this.toastMessage = 'Nenhum motorista logado!';
      this.showToast = true;
      return;
    }

    const motorista = this.motoristas[0];
    const horaAtual = this.getHoraAtual();
    const status = await Network.getStatus();

    const payload = {
      usuario_id: motorista.usuarioId,
      folha_servico_id: motorista.idFolhaServico,
      data_servico: motorista.dataServico,
      resumo_papeleta_empregado_id: motorista.resumoPapeletaEmpregadoId,
      numero_papeleta: motorista.papeleta,
      latitude_inicio: this.latitude,
      longitude_inicio: this.longitude,
      hora_inicial: horaAtual,
      horario_inicial: motorista.horarioInicial,
      horario_final: motorista.horarioFinal,
      id: motorista.idFolhaServico,
      horaInicial: horaAtual,
      latitude_papeleta_inicio: this.latitude,
      longitude_papeleta_inicio: this.longitude,
      coletorMarcacao: this.getColetorMarcacao(),
      inSituacao: "B"
    };

    try {
      const response = await this.jornadaServicoService.iniciarJornadaServicoOffline(payload);
      console.log('Papeleta em branco iniciada:', response);

      // Cria acerto temporário
      const novoAcertoTemp: AcertoHoraDTO = {
        id: Date.now(),
        hora: horaAtual,
        statusAcertoHora: 'Pendente',
        excluido: false,
        folhaServicoId: motorista.idFolhaServico,
        usuario: motorista.matricula?.toString(),
        origem: 'temp',
        offline: !status.connected,
        coletorMarcacao: this.getColetorMarcacao()
      };

      if (!this.horariosTemporarios[motorista.idFolhaServico]) {
        this.horariosTemporarios[motorista.idFolhaServico] = [];
      }
      this.horariosTemporarios[motorista.idFolhaServico].push(novoAcertoTemp);
      this.atualizarListaAcertosComTemporarios(motorista.idFolhaServico);
      this.cdr.detectChanges();

      this.papeletaBrancoAtiva = true;
      this.atualizarVisibilidadeBotoes();

      this.toastMessage = 'Papeleta em branco iniciada com sucesso!';
      this.showToast = true;

    } catch (error) {
      console.error('Erro ao iniciar papeleta em branco:', error);
      this.toastMessage = 'Erro ao iniciar papeleta em branco!';
      this.showToast = true;
    }
  }

  // Método para finalizar papeleta em branco
  async finalizarPapeletaEmBranco() {
    if (!this.tokenAutenticacao) {
      this.toastMessage = 'Faça login primeiro!';
      this.showToast = true;
      return;
    }

    if (!this.motoristas.length) {
      this.toastMessage = 'Nenhum motorista logado!';
      this.showToast = true;
      return;
    }

    const motorista = this.motoristas[0];
    const horaAtual = this.getHoraAtual();
    const status = await Network.getStatus();

    const payload = {
      usuario_id: motorista.usuarioId,
      numero_papeleta: motorista.papeleta,
      observacao: 'Finalização pelo app',
      latitude_fim: this.latitude,
      longitude_fim: this.longitude,
      hora_final: horaAtual,
      folha_servico_id: motorista.idFolhaServico,
      offline: !status.connected,
      coletorMarcacao: this.getColetorMarcacao()
    };

    try {
      const response = await this.jornadaServicoService.finalizarJornadaServicoOffline(payload);
      console.log('Papeleta em branco finalizada:', response);

      const novoAcertoTemp: AcertoHoraDTO = {
        id: Date.now(),
        hora: horaAtual,
        statusAcertoHora: 'Pendente',
        excluido: false,
        folhaServicoId: motorista.idFolhaServico,
        usuario: motorista.matricula?.toString(),
        offline: !status.connected,
        coletorMarcacao: this.getColetorMarcacao()
      };

      if (!this.horariosTemporarios[motorista.idFolhaServico]) {
        this.horariosTemporarios[motorista.idFolhaServico] = [];
      }
      this.horariosTemporarios[motorista.idFolhaServico].push(novoAcertoTemp);
      this.atualizarListaAcertosComTemporarios(motorista.idFolhaServico);
      this.cdr.detectChanges();

      this.papeletaBrancoAtiva = false;
      this.atualizarVisibilidadeBotoes();

      this.toastMessage = 'Papeleta em branco finalizada com sucesso!';
      this.showToast = true;

    } catch (error) {
      console.error('Erro ao finalizar papeleta em branco:', error);
      this.toastMessage = 'Erro ao finalizar papeleta em branco!';
      this.showToast = true;
    }
  }

  async verificarPapeletaBrancoAtiva() {
    if (!this.motoristas.length) return;
    const motorista = this.motoristas[0];
    try {
      const acertos = await this.acertoHoraService.listar(motorista.idFolhaServico, motorista.usuarioId).toPromise();
      const acertosNaoExcluidos = (acertos || []).filter(a => !a.excluido);
      const totalAcertos = acertosNaoExcluidos.length;
      this.papeletaBrancoAtiva = totalAcertos % 2 !== 0;
      this.atualizarVisibilidadeBotoes();
    } catch (error) {
      console.error('Erro ao verificar papeleta em branco:', error);
    }
  }

  atualizarVisibilidadeBotoes() {
    if (!this.motoristas.length) return;

    const motorista = this.motoristas[0];
    const folhaServicoId = motorista.idFolhaServico;

    // Pega acertos para esta folha
    const acertos = this.acertosHorarios.filter(
      a => a.folhaServicoId === folhaServicoId && !a.excluido
    );

    const totalAcertos = acertos.length;

    this.botaoStatus[folhaServicoId] = totalAcertos % 2 === 0;

    this.exibirBotoesJornadaNormal = true;

    this.cdr.detectChanges();
  }

  /*async verificarTipoPapeletaAtiva(folhaServicoId: number) {
    try {
      // Pega acertos do banco para esta folha
      const acertos = this.acertosHorarios.filter(
        a => a.folhaServicoId === folhaServicoId &&
          !a.excluido &&
          (a as any).origem === 'banco'
      );

      if (acertos.length === 0) {
        // Sem acertos, padrao G
        this.tipoPapeletaAtiva = 'G';
        this.atualizarVisibilidadeBotoes();
        return;
      }

      // Pega o inSituacao do ULTIMO acerto (mais recente pela hora)
      const acertosOrdenados = [...acertos].sort((a, b) => {
        const horaA = a.hora || '';
        const horaB = b.hora || '';
        return horaA.localeCompare(horaB);
      });

      const ultimoAcerto = acertosOrdenados[acertosOrdenados.length - 1];

      // Se o ultimo acerto tem inSituacao 'B', é papeleta em branco
      if (ultimoAcerto.inSituacao === 'B') {
        this.tipoPapeletaAtiva = 'B';
      } else {
        this.tipoPapeletaAtiva = 'G';
      }

      this.atualizarVisibilidadeBotoes();

    } catch (error) {
      console.error('Erro ao verificar tipo de papeleta:', error);
      this.tipoPapeletaAtiva = 'G';
    }
  }*/

  async verificarTipoPapeletaAtiva(folhaServicoId: number) {
    this.atualizarBotaoStatus(folhaServicoId);
  }

  // Adicione este método na classe
  private podeAssinarPapeleta(motorista: any): { pode: boolean; mensagem: string } {
    // Pega todos os acertos NÃO excluídos deste motorista
    const acertosValidos = this.acertosHorarios.filter(acerto =>
      acerto.folhaServicoId === motorista.idFolhaServico &&
      !acerto.excluido
    );

    const totalAcertos = acertosValidos.length;

    // Verifica se o número de acertos é ímpar (jornada em aberto)
    if (totalAcertos % 2 !== 0) {
      return {
        pode: false,
        mensagem: 'Não é possível assinar a papeleta pois há uma jornada em aberto. Finalize a jornada de trabalho primeiro.'
      };
    }

    // Verifica se tem pelo menos um acerto
    if (totalAcertos === 0) {
      return {
        pode: false,
        mensagem: 'Não é possível assinar a papeleta pois não há nenhum horário registrado.'
      };
    }

    return {
      pode: true,
      mensagem: ''
    };
  }

  private podeAssinarPapeletaDoDia(dia: DiaApuradoCorrecao): { pode: boolean; mensagem: string } {
    // Verifica se o número de marcações é par
    const totalMarcacoes = dia.marcacoes.length;

    if (totalMarcacoes % 2 !== 0) {
      return {
        pode: false,
        mensagem: `Não é possível assinar a papeleta do dia ${dia.data.toLocaleDateString('pt-BR')} pois há uma jornada em aberto. Finalize a jornada de trabalho primeiro.`
      };
    }

    if (totalMarcacoes === 0) {
      return {
        pode: false,
        mensagem: `Não é possível assinar a papeleta do dia ${dia.data.toLocaleDateString('pt-BR')} pois não há nenhum horário registrado.`
      };
    }

    return {
      pode: true,
      mensagem: ''
    };
  }

  // Método para visualizar PDF (visualização simples, sem assinar)
  async visualizarPDF(motorista: any) {
    if (!motorista.matricula || !motorista.dataServico) {
      this.toastMessage = 'Dados insuficientes para gerar o PDF.';
      this.showToast = true;
      return;
    }

    if (!motorista.idFolhaServico) {
      this.toastMessage = 'ID da folha de serviço não encontrado!';
      this.showToast = true;
      return;
    }

    const loading = await this.alertController.create({
      message: 'Preparando dados...',
      backdropDismiss: false
    });
    await loading.present();

    try {
      const data = motorista.dataServico.split('T')[0];

      // 🔥 PASSA O FOLHA_SERVICO_ID
      this.relatorioService
        .visualizarPDF(motorista.matricula, data, motorista.idFolhaServico)
        .subscribe({
          next: (blob: Blob) => {
            loading.dismiss();
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
          },
          error: (error) => {
            loading.dismiss();
            console.error('Erro ao gerar PDF:', error);
            this.toastMessage = error?.mensagem || error?.erro || 'Erro ao gerar o PDF.';
            this.showToast = true;
          }
        });
    } catch (error) {
      loading.dismiss();
      console.error('Erro:', error);
      this.toastMessage = 'Erro ao preparar dados para o PDF.';
      this.showToast = true;
    }
  }

  // Adicione este método na classe FirstPageComponent
  private criarDataParaComparacao(data: string, hora: string): Date {
    if (!data || !hora) return new Date(0);

    const dataStr = data.split('T')[0];
    const [ano, mes, dia] = dataStr.split('-').map(Number);

    let horas = 0;
    let minutos = 0;

    if (hora.includes(':')) {
      const partes = hora.split(':');
      horas = parseInt(partes[0], 10);
      minutos = parseInt(partes[1], 10);
    }

    return new Date(ano, mes - 1, dia, horas, minutos);
  }
  imprimir(motorista: any) {
    this.folhaServicoService.imprimirPorMatricula(+motorista.matricula);
  }

  conectarImpressora() {
    this.elginPrintService.vincularDispositivo().then(
      (device) => this.impressoraConectada = device != null
    );
  }

  async verificarPendenciasAssinatura(matricula: number): Promise<void> {
    if (this.alertaFechadoPermanente) {
      console.log('Alerta já foi fechado permanentemente nesta sessão');
      return;
    }

    // Valida se a matrícula foi fornecida
    if (!matricula || matricula <= 0) {
      console.warn('Matrícula inválida para verificação de pendências');
      return;
    }

    try {
      console.log(`🔍 Verificando folhas pendentes para matrícula: ${matricula}`);

      this.folhaServicoService.verificarFolhasPendentesAssinatura(matricula).subscribe({
        next: (resultado) => {
          console.log('📋 Resultado da verificação:', resultado);

          if (resultado && resultado.possuiPendencia) {
            this.dadosPendentesAssinatura = resultado;
            this.mensagemAlertaPendentes = resultado.mensagem;

            // Exibe o alerta
            this.mostrarAlertaPendentes = true;

            console.log(`⚠️ ${resultado.quantidadePapeletas} folha(s) pendente(s) encontrada(s) para os dias:`, resultado.datasPapeletas);
          } else {
            console.log('✅ Nenhuma folha pendente de assinatura encontrada');
          }
        },
        error: (error) => {
          console.error('❌ Erro ao verificar pendências de assinatura:', error);
        }
      });
    } catch (error) {
      console.error('❌ Erro inesperado na verificação de pendências:', error);
    }
  }

  fecharAlertaPendentes(): void {
    console.log('Fechando alerta de pendências');
    this.mostrarAlertaPendentes = false;
  }

  fecharAlertaPendentesPermanente(): void {
    console.log('Fechando alerta de pendências permanentemente para esta sessão');
    this.mostrarAlertaPendentes = false;
    this.alertaFechadoPermanente = true;

    // Mostra uma mensagem de confirmação
    this.toastMessage = 'Você não receberá mais alertas sobre estas pendências nesta sessão.';
    this.showToast = true;
  }

  limparEstadoAlertaPendentes(): void {
    this.mostrarAlertaPendentes = false;
    this.mensagemAlertaPendentes = '';
    this.dadosPendentesAssinatura = null;
    this.alertaFechadoPermanente = false;
  }

  // Método para limpar os dados do motorista antes de recarregar
  private limparDadosMotorista() {
    this.motoristas = [];
    this.motoristasFiltrados = [];
    this.acertosHorarios = [];
    this.horariosTemporarios = {};
    this.statusDias.clear();
    this.botaoStatus = {};
    this.diasApuradosCorrecao = [];
    this.diasFiltradosCorrecao = [];
  }

  // Método para carregar dados substituindo os antigos (como se fosse login)
  async carregarDadosMotoristaCompleto(identificador: string) {
    return new Promise<void>((resolve) => {
      this.motoristaService.listarMotoristas().subscribe({
        next: (data) => {
          const motoristaEncontrado = data.find(m =>
            m.matricula === identificador ||
            m.cpf === identificador
          );

          if (motoristaEncontrado) {
            // 🔥 SUBSTITUI COMPLETAMENTE OS DADOS (não adiciona)
            this.motoristas = [motoristaEncontrado];
            this.motoristasFiltrados = [motoristaEncontrado];
            this.searchTerm = motoristaEncontrado.matricula;

            this.carregarMensagensMotorista();

            // 🔥 RECARREGA OS ACERTOS (SUBSTITUINDO)
            this.carregarAcertosHorariosSubstituindo(
              motoristaEncontrado.idFolhaServico,
              motoristaEncontrado.usuarioId
            );

            const matriculaNumero = parseInt(motoristaEncontrado.matricula, 10);
            if (!isNaN(matriculaNumero)) {
              this.verificarPendenciasAssinatura(matriculaNumero);
            }
          } else {
            this.toastMessage = 'Motorista não encontrado!';
            this.showToast = true;
          }
          resolve();
        },
        error: (err) => {
          console.error('Erro ao carregar motorista:', err);
          this.toastMessage = 'Erro ao carregar dados do motorista!';
          this.showToast = true;
          resolve();
        }
      });
    });
  }

  // Método para carregar acertos substituindo (não adicionando)
  carregarAcertosHorariosSubstituindo(folhaServicoId: number, usuarioId: number) {
    this.acertoHoraService.listar(folhaServicoId, usuarioId).subscribe({
      next: (acertos: AcertoHoraDTO[]) => {
        const acertosNaoExcluidos = (acertos || []).filter(acerto => {
          return !acerto.excluido && acerto.hora && acerto.hora.trim() !== '';
        });

        // Marca os que vieram do banco
        acertosNaoExcluidos.forEach(a => (a as any).origem = 'banco');

        // 🔥 SUBSTITUI COMPLETAMENTE OS ACERTOS (não adiciona)
        this.acertosHorarios = acertosNaoExcluidos;

        // Remove temporários antigos
        this.horariosTemporarios = {};

        // Atualiza o status do botão
        this.atualizarBotaoStatus(folhaServicoId);

        this.verificarTipoPapeletaAtiva(folhaServicoId);

        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Erro ao carregar acertos:', err);
      }
    });
  }

  private converterHoraEstendidaParaMinutos(hora: string): number {
    if (!hora || !hora.includes(':')) return 0;

    const [horasStr, minutosStr] = hora.split(':');
    const horas = parseInt(horasStr, 10);
    const minutos = parseInt(minutosStr, 10);

    if (isNaN(horas) || isNaN(minutos)) return 0;

    // Retorna minutos totais (permite horas > 24)
    return (horas * 60) + minutos;
  }

  private calcularHoraEstendida(hora: string, dataAcerto: string, dataReferencia: Date): string {
    if (!hora) return '00:00';

    const dataAcertoObj = new Date(dataAcerto + 'T00:00:00');
    const dataReferenciaObj = new Date(dataReferencia);
    dataReferenciaObj.setHours(0, 0, 0, 0);

    if (dataAcertoObj > dataReferenciaObj) {
      const diffDias = Math.floor((dataAcertoObj.getTime() - dataReferenciaObj.getTime()) / (1000 * 60 * 60 * 24));
      if (diffDias > 0) {
        const [horas, minutos] = hora.split(':');
        const novaHora = (parseInt(horas, 10) + (diffDias * 24)).toString().padStart(2, '0');
        return `${novaHora}:${minutos}`;
      }
    }

    return hora;
  }

  private extrairMensagemErro(erro: any, mensagemFallback: string = 'Erro ao processar solicitação.'): string {
    if (erro.error?.erro) {
      return erro.error.erro;
    }

    if (erro.error?.message) {
      return erro.error.message;
    }

    if (erro.message) {
      return erro.message;
    }

    if (typeof erro === 'string') {
      return erro;
    }

    return mensagemFallback;
  }

  // Coloque este método na sua classe
  private normalizarHora(hora: string): string {
    if (!hora) return '';

    // Remove espaços
    hora = hora.trim();

    // Se já tem ":", padroniza
    if (hora.includes(':')) {
      const partes = hora.split(':');
      let h = partes[0].padStart(2, '0');  // 9 -> 09
      let m = partes[1] ? partes[1].padStart(2, '0') : '00';  // 5 -> 50
      return `${h}:${m}`;
    }

    // Se não tem ":", assume que são números puros
    const numeros = hora.replace(/\D/g, '');
    if (numeros.length === 1) return `0${numeros}:00`;  // 9 -> 09:00
    if (numeros.length === 2) return `${numeros}:00`;    // 95 -> 95:00
    if (numeros.length === 3) return `${numeros.substring(0, 2)}:${numeros.substring(2)}0`; // 950 -> 95:00
    if (numeros.length >= 4) return `${numeros.substring(0, 2)}:${numeros.substring(2, 4)}`; // 9505 -> 95:05

    return hora;
  }
  // Adicione estes métodos na classe FirstPageComponent

  abrirAjudaLogin() {
    window.open('https://innovatransit.com.br/ajudatotemlogin/', '_blank');
  }

  abrirAjudaJornada() {
    window.open('https://innovatransit.com.br/ajudatotemjornada/', '_blank');
  }

  abrirProximasEscalas() {
    this.mostrarModalEscalas = true;
  }

  fecharModalEscalas() {
    this.mostrarModalEscalas = false;
  }

  async obterLocalizacaoVeiculo(motorista: any) {
    const numeroVeiculo = motorista?.veiculo;

    if (!numeroVeiculo || numeroVeiculo === 0) {
      this.toastMessage = 'Número do veículo não disponível.';
      this.showToast = true;
      return;
    }

    // Verifica se está online
    const status = await Network.getStatus();
    if (!status.connected) {
      console.log('📡 Offline - Ignorando busca de localização');
      this.toastMessage = 'Sem conexão com a internet para buscar a localização.';
      this.showToast = true;
      return;
    }

    // Mostra loading
    this.carregandoLocalizacaoVeiculo = true;
    const loading = await this.alertController.create({
      message: `Buscando localização do veículo ${numeroVeiculo}...`,
      backdropDismiss: false
    });
    await loading.present();

    // Busca a localização
    this.telemetriaService.obterLocalizacaoVeiculo(parseInt(numeroVeiculo, 10)).subscribe({
      next: async (localizacao) => {
        await loading.dismiss();
        this.carregandoLocalizacaoVeiculo = false;

        console.log(`📍 Veículo ${numeroVeiculo} - Lat: ${localizacao.latitude}, Lng: ${localizacao.longitude}`);

        // Abre o mapa com as coordenadas
        this.abrirMapa(localizacao.latitude, localizacao.longitude);
      },
      error: async (error) => {
        await loading.dismiss();
        this.carregandoLocalizacaoVeiculo = false;
        console.error('Erro ao buscar localização:', error);

        this.toastMessage = `Erro ao buscar localização do veículo ${numeroVeiculo}`;
        this.showToast = true;
      }
    });
  }

  abrirMapa(latitude: number, longitude: number) {
    // Verifica se está em ambiente mobile (Capacitor/Cordova)
    if (Capacitor.isNativePlatform()) {
      // Abre no Google Maps app
      window.open(`geo:${latitude},${longitude}?q=${latitude},${longitude}`, '_system');
    } else {
      // Abre no navegador
      window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, '_blank');
    }
  }

  async carregarMensagensMotorista() {
    // Verifica se está online
    const status = await Network.getStatus();
    if (!status.connected) {
      console.log('📡 Offline - Ignorando carregamento de mensagens');
      return;
    }

    if (!this.motoristas.length) {
      console.warn('⚠️ Nenhum motorista encontrado');
      return;
    }

    const motorista = this.motoristas[0];
    const usuarioId = motorista.usuarioId;
    const dataServico = motorista.dataServico;

    if (!usuarioId || !dataServico) {
      console.warn('⚠️ Usuário ou data não disponível');
      return;
    }

    // Formata a data para YYYY-MM-DD
    const dataFormatada = this.formatarDataParaBackend(dataServico);

    this.mensagemService.listarMensagens(usuarioId, dataFormatada).subscribe({
      next: (mensagens) => {
        this.mensagensMotorista = mensagens;
        console.log('📩 Mensagens carregadas:', mensagens.length);
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('❌ Erro ao carregar mensagens:', err);
        this.mensagensMotorista = [];
      }
    });
  }

  private formatarDataParaBackend(data: string): string {
    if (!data) return new Date().toISOString().split('T')[0];

    if (data.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return data;
    }

    if (data.includes('/')) {
      const partes = data.split('/');
      return `${partes[2]}-${partes[1]}-${partes[0]}`;
    }

    return data;
  }

  abrirPapeletaExterna() {
    if (!this.motoristas.length) {
      this.toastMessage = 'Nenhum motorista logado!';
      this.showToast = true;
      return;
    }

    this.mostrarModalPapeletaExterna = true;
    this.papeletaExternaCarregando = true;
    this.papeletaExternaSemDados = false;
    this.folhaExterna = null;
    this.listaTarefasExterna = [];

    const motorista = this.motoristas[0];
    const matricula = Number(motorista.matricula);
    const dataServico = motorista.dataServico.split('T')[0];

    this.papeletaExternaService.buscarPapeletaExterna(matricula, dataServico).subscribe({
      next: (folhas: any[]) => {
        this.papeletaExternaCarregando = false;

        if (!folhas || folhas.length === 0) {
          this.papeletaExternaSemDados = true;
          return;
        }

        this.folhaExterna = folhas[0];
        this.listaTarefasExterna = this.folhaExterna.tarefas || [];
      },
      error: (error) => {
        this.papeletaExternaCarregando = false;

        if (error.status === 404) {
          this.papeletaExternaSemDados = true;
          return;
        }

        console.error('Erro ao buscar papeleta externa:', error);
        this.papeletaExternaSemDados = true;
      }
    });
  }

  fecharPapeletaExterna() {
    this.mostrarModalPapeletaExterna = false;
    this.folhaExterna = null;
    this.listaTarefasExterna = [];
    this.papeletaExternaSemDados = false;
  }

  formatarHoraExterna(hora: string | null | undefined): string {
    if (!hora) return '';
    const partes = hora.split(':');
    return `${partes[0]}:${partes[1]}`;
  }

  formatarLinhaPrefixoExterna(linhaPrefixo: string): string {
    if (!linhaPrefixo || linhaPrefixo.length === 0) return '';
    const ultimo = linhaPrefixo.slice(-1);
    const resto = linhaPrefixo.slice(0, -1);
    return `${resto}-${ultimo}`;
  }
}